// ArChat Language Extension
// Created: 13-03-2026 00:00:00
// Author: SIVOL® - Aldo Frias - Argentina

import { translationsEn } from './translations.en.js';
import { PRESET_LOCALES } from '../presencePresetI18n.js';

export const translationsEl = {
  ...translationsEn,
  'common.loading': 'Φόρτωση…',
  'common.cancel': 'Ακύρωση',
  'common.confirm': 'Επιβεβαίωση',
  'common.close': 'Κλείσιμο',
  'common.sending': 'Αποστολή...',
  'common.language': 'Γλώσσα',
  'home.language': 'Γλώσσα',
  'app.install': 'Εγκατάσταση ArChat',
  'login.title': 'Σύνδεση',
  'register.pageTitle': 'Δημιουργία λογαριασμού',
  'onboarding.welcome_title': 'Καλώς ήρθατε στο ArChat®',
  'onboarding.step1_description': 'Προσκάλεσε την πρώτη σου επαφή',
  'onboarding.step2_description': 'Στείλε το πρώτο σου μήνυμα',
  'onboarding.explore_archat': 'Εξερεύνησε το ArChat®',
  'common.continue': 'Συνέχεια',
  'common.backToStart': 'Επιστροφή στην αρχική',
  'auth.invalid_credentials': 'Λανθασμένο όνομα χρήστη ή κωδικός.',
  'auth.user_not_found': 'Ο χρήστης δεν βρέθηκε.',
  'auth.user_inactive': 'Ο λογαριασμός σας είναι ανενεργός. Επικοινωνήστε με τον διαχειριστή.',
  'auth.captcha_failed': 'Λανθασμένο CAPTCHA. Ελέγξτε την απάντησή σας.',
  'auth.generic_error': 'Παρουσιάστηκε σφάλμα. Δοκιμάστε ξανά.',
  'auth.password_mismatch': 'Οι κωδικοί δεν ταιριάζουν.',
  'auth.rate_limit': 'Πάρα πολλές προσπάθειες. Περιμένετε λίγο και δοκιμάστε ξανά.',
  'contacts.no_contacts': 'Δεν υπάρχουν επαφές',
  'contacts.invite_contact': 'Πρόσκληση επαφής',
  'contacts.empty.title': 'Δεν έχετε επαφές ακόμη',
  'contacts.empty.message': 'Στείλτε πρόσκληση για να ξεκινήσετε την πρώτη σας συνομιλία.',
  'contacts.empty.invite_button': 'Πρόσκληση επαφής',
  'contacts.title': 'Επαφές',
  'contacts.search': 'Αναζήτηση επαφής',
  'contacts.sort': 'Ταξινόμηση',
  'contacts.sortByName': 'Κατά όνομα',
  'contacts.sortByStatus': 'Κατά κατάσταση',
  'contacts.sortByRecent': 'Πρόσφατα',
  'contacts.filter': 'Φίλτρο',
  'contacts.filterAll': 'Όλα',
  'contacts.filterAvailable': 'Διαθέσιμοι',
  'contacts.filterInvited': 'Προσκεκλημένοι',
  'contacts.filterBlocked': 'Αποκλεισμένοι',
  'contacts.pending_invitations': 'Εκκρεμείς προσκλήσεις',
  'contacts.status.invitation_sent': 'Η πρόσκληση στάλθηκε',
  'contacts.conversations': 'Συνομιλίες',
  'contacts.search_contact': 'Αναζήτηση επαφής',
  'contacts.controls.search_placeholder': 'Αναζήτηση επαφής...',
  'contacts.controls.search_label': 'Αναζήτηση επαφής',
  'contacts.controls.sort_label': 'Ταξινόμηση κατά',
  'profile.title': 'Το προφίλ μου',
  'profile.edit': 'Επεξεργασία',
  'profile.save': 'Αποθήκευση αλλαγών',
  'profile.cancel': 'Ακύρωση',
  'profile.language': 'Γλώσσα',
  'menu.contacts': 'Επαφές',
  'menu.dashboard': 'Πίνακας ελέγχου',
  'menu.help': 'Βοήθεια',
  'menu.logout': 'Αποσύνδεση',
  'menu.files': 'Τα αρχεία μου',
  'reviews.menu_title': 'Κριτικές',
  'reviews.rate_archat': 'Αξιολόγηση ArChat',
  'reviews.my_review': 'Η κριτική μου',
  'menu.profile': 'Το προφίλ μου',
  'menu.settings': 'Ρυθμίσεις',
  'profile.my_profile': 'Το προφίλ μου',
  'profile.status': 'Κατάσταση',
  'profile.invite_email': 'Πρόσκληση επαφής μέσω email',
  'profile.sent_invitations': 'Απεσταλμένες προσκλήσεις',
  'profile.users': 'Χρήστες',
  'profile.settings': 'Ρυθμίσεις',
  'profile.appearance': 'Εμφάνιση',
  'profile.logout': 'Αποσύνδεση',
  'navbar.status': 'Κατάσταση',
  'navbar.contacts': 'Επαφές',
  'status.available': 'Διαθέσιμος',
  'status.busy': 'Απασχολημένος',
  'status.in_call': 'Σε κλήση',
  'status.away': 'Απών',
  'status.offline': 'Εκτός σύνδεσης',
  'status.custom': 'Προσαρμοσμένο μήνυμα',
  'status.set_title': 'Κατάσταση διαθεσιμότητας',
  'status.set_button': 'Αλλαγή κατάστασης',
  'status.placeholder': 'Προαιρετικό μήνυμα (π.χ. Σε σύσκεψη)',
  'contacts.available': 'Διαθέσιμος',
  'contacts.controls.filter_label': 'Κατάσταση',
  'contacts.controls.filter.available': 'Διαθέσιμοι',
  'contacts.controls.sort.status': 'Κατάσταση',
  'contacts.status': 'Κατάσταση',
  'invitation.title': 'Πρόσκληση επαφής',
  'invitation.modal.title': 'Αποστολή πρόσκλησης',
  'invitation.modal.description': 'Προσκαλέστε κάποιον να συνομιλήσει μαζί σας στο ArChat®. Θα λάβει email με σύνδεσμο αποδοχής της πρόσκλησης.',
  'invitation.email.label': 'Email προσκεκλημένου',
  "invitation.email.placeholder": "ejemplo@email.com",
  'invitation.email.required': 'Το email είναι υποχρεωτικό',
  'invitation.email.invalid': 'Παρακαλώ εισάγετε έγκυρο email',
  'invitation.language.label': 'Προτιμώμενη γλώσσα προσκεκλημένου',
  'invitation.language.help': 'Το email θα σταλεί σε αυτή τη γλώσσα',
  'invitation.mode.label': 'Τρόπος συνομιλίας',
  'invitation.mode.profesional': 'Επαγγελματικός',
  'invitation.mode.profesional.description': 'Επίσημη και επαγγελματική συνομιλία',
  'invitation.mode.tecnico': 'Τεχνικός',
  'invitation.mode.tecnico.description': 'Τεχνική και εξειδικευμένη συνομιλία',
  'invitation.mode.casual': 'Φιλικός',
  'invitation.mode.casual.description': 'Ανεπίσημη και φιλική συνομιλία',
  'invitation.message.label': 'Προσωπικό μήνυμα (προαιρετικό)',
  'invitation.message.placeholder': 'Γράψτε ένα προσωπικό μήνυμα για τον προσκεκλημένο...',
  'invitation.send': 'Αποστολή πρόσκλησης',
  'invitation.sending': 'Αποστολή...',
  'invitation.success': 'Η πρόσκληση στάλθηκε με επιτυχία',
  'invitation.success.title': 'Η πρόσκληση στάλθηκε',
  'invitation.success.message': 'Η πρόσκληση στάλθηκε με επιτυχία.\n\nΗ επαφή θα λάβει email με σύνδεσμο αποδοχής. Μόλις την αποδεχθεί, μπορείτε να ξεκινήσετε συνομιλία.',
  'invitation.error': 'Σφάλμα κατά την αποστολή της πρόσκλησης',
  'invitation.error.self': 'Δεν μπορείτε να προσκαλέσετε τον εαυτό σας',
  'invitation.error.duplicate': 'Υπάρχει ήδη εκκρεμής πρόσκληση για αυτό το email',
  'invitation.list.title': 'Απεσταλμένες προσκλήσεις',
  'invitation.list.empty': 'Δεν έχετε στείλει ακόμη προσκλήσεις',
  "invitation.list.email": "E-mail",
  'invitation.list.language': 'Γλώσσα',
  'invitation.list.mode': 'Τρόπος',
  'invitation.list.status': 'Κατάσταση',
  'invitation.list.created': 'Αποστολή',
  'invitation.list.expires': 'Λήγει',
  'invitation.list.actions': 'Ενέργειες',
  'invitation.status.pending': 'Σε εκκρεμότητα',
  'invitation.status.accepted': 'Αποδεκτή',
  'invitation.status.expired': 'Έληξε',
  'invitation.status.cancelled': 'Ακυρωμένη',
  'invitation.status.deleted': 'Διαγραμμένη',
  'invitation.status.rejected': 'Απορρίφθηκε',
  "invitation.status.bounced": "Αναπήδησε",
  "invitation.status.unknown": "Άγνωστη κατάσταση",
  'invitation.deleted.tooltip': 'Αυτή η πρόσκληση διαγράφηκε',
  'invitation.cancel': 'Ακύρωση',
  'invitation.cancel.confirm': 'Είστε βέβαιοι ότι θέλετε να ακυρώσετε αυτή την πρόσκληση;',
  'invitation.cancel.success': 'Η πρόσκληση ακυρώθηκε με επιτυχία',
  'invitation.cancel.title': 'Επιβεβαίωση ακύρωσης',
  'invitation.resend': 'Επανάληψη αποστολής email',
  'invitation.resend.title': 'Επανάληψη πρόσκλησης',
  'invitation.resend.success': 'Το email πρόσκλησης εστάλη ξανά με επιτυχία',
  'invitation.resend.error': 'Σφάλμα κατά την επανάληψη αποστολής του email',
  'invitations.columns.mode': 'Τρόπος',
  'invitations.actions.resend': 'Επανάληψη αποστολής email',
  'invitations.actions.cancel': 'Ακύρωση πρόσκλησης',
  'invitations.pending.title': 'Εκκρεμείς προσκλήσεις',
  'invitations.sent.title': 'Απεσταλμένες προσκλήσεις',
  'dashboard.title': 'Πίνακας ελέγχου',
  'dashboard.planUsage': 'Χρήση πλάνου',
  'dashboard.filesSummary': 'Τα αρχεία μου',
  'dashboard.promotions': 'Προσφορές',
  'dashboard.sessions': 'Ενεργές συνεδρίες',
  'dashboard.explore': 'Εξερεύνηση',
  'dashboard.noSessions': 'Καμία ενεργή συνεδρία',
  'dashboard.welcomeTitle': 'Καλώς ήρθατε στο ArChat®',
  'dashboard.welcomeSubtitle': 'Επικοινωνήστε σε οποιαδήποτε γλώσσα.',
  'dashboard.stepInvite': 'Βήμα 1: προσκαλέστε την πρώτη επαφή',
  'dashboard.stepMessage': 'Βήμα 2: στείλτε το πρώτο μήνυμα',
  'dashboard.inviteContact': 'Πρόσκληση επαφής',
  'dashboard.exploreArChat': 'Εξερευνήστε το ArChat',
  'dashboard.promotionsTitle': 'Προσφορές',
  'dashboard.promotionsText': 'Περίληψη του προγράμματος παραπομπών και ανταμοιβών.',
  'dashboard.viewPromotions': 'Προβολή προσφορών',
  'dashboard.usageTitle': 'Χρήση πλάνου',
  'dashboard.sessionsTitle': 'Ενεργές συνεδρίες',
  'dashboard.sessionsEmpty': 'Δεν υπάρχουν ενεργές συνεδρίες',
  'dashboard.filesTitle': 'Τα αρχεία μου',
  'dashboard.viewFiles': 'Άνοιγμα αρχείων',
  'dashboard.noBlocks': 'Κανένα ενεργό block. Ενεργοποιήστε τουλάχιστον ένα στις Ρυθμίσεις.',
  'dashboard.openSettings': 'Άνοιγμα ρυθμίσεων',
  'dashboard.goToContacts': 'Στις επαφές',
  'dashboard.filesVisible': 'Ορατά αρχεία',
  'dashboard.filesSampleNote': 'Μέτρηση από τη 1η σελίδα (έως 500+).',
  'dashboard.card.contacts': 'Επαφές',
  'navbar.users': 'Χρήστες',
  'contacts.controls.sort.name': 'Όνομα',
  'contacts.controls.sort.recent': 'Πρόσφατα',
  'contacts.controls.sort.manual': 'Χειροκίνητα',
  'contacts.controls.sort.manual_drag_hint': 'Σύρετε για αναδιάταξη',
  'contacts.controls.filter.all': 'Όλα',
  'contacts.controls.filter.invited': 'Προσκεκλημένοι',
  'contacts.controls.filter.blocked': 'Αποκλεισμένοι',
  'contacts.controls.filter.favorites': 'Αγαπημένα',
  'menu.open': 'Μενού',
  'contacts.controls.hide_non_favorites': 'Απόκρυψη μη αγαπημένων επαφών',
  'contacts.controls.show_all': 'Εμφάνιση όλων των επαφών',
  'common.navigation': 'Πλοήγηση',
  'common.favorite': 'Αγαπημένο',
  'common.block': 'Αποκλεισμός',
  'common.user': 'Χρήστης',
  'message.new': 'Νέο μήνυμα',
  'message.edit': 'Επεξεργασία μηνύματος',
  'message.edit.save': 'Αποθήκευση επεξεργασίας',
  'message.edit.cancel': 'Ακύρωση επεξεργασίας',
  'message.translating': 'Μετάφραση...',
  'message.translation_failed': 'Η μετάφραση απέτυχε',
  'message.not_translated': 'Αρχικό κείμενο',
  'message.retry_send': 'Επανάληψη',
  'message.retrying': 'Επανάληψη...',
  'message.delete': 'Διαγραφή μηνύματος',
  'message.deleted_placeholder': 'Το μήνυμα διαγράφηκε',
  'message.edited': 'Επεξεργάστηκε',
  'message.edited_at': 'Επεξεργάστηκε στις',
  'message.delete_for_me.tooltip': 'Διαγραφή μόνο για μένα',
  'message.delete_for_me.aria': 'Διαγραφή αυτού του μηνύματος μόνο για μένα',
  'message.delete_for_me.confirm_title': 'Διαγραφή μηνύματος',
  'message.delete_for_me.confirm_message': 'Αυτό το μήνυμα θα διαγραφεί μόνο από τη δική σας προβολή.',
  'message.delete_for_everyone.tooltip': 'Διαγραφή για όλους',
  'message.delete_for_everyone.aria': 'Διαγραφή αυτού του μηνύματος για όλους τους συμμετέχοντες',
  'message.delete_for_everyone.confirm_title': 'Διαγραφή μηνύματος για όλους',
  'message.delete_for_everyone.confirm_message': 'Αυτό το μήνυμα θα διαγραφεί για εσάς και τον άλλο συμμετέχοντα.',
  'message.delete_for_everyone.window_expired': 'Το χρονικό όριο διαγραφής έληξε',
  'message.translation.show': 'Προβολή πρωτότυπου και μετάφρασης',
  'message.translation.hide': 'Απόκρυψη μετάφρασης',
  'emoji.search': 'Αναζήτηση emoji',
  'emoji.close': 'Κλείσιμο επιλογέα',
  'captcha.refresh': 'Ανανέωση CAPTCHA',
  'presence.unavailable': 'Οι καταστάσεις δεν είναι διαθέσιμες',
  'presence.maintenance': 'Ο διακομιστής είναι υπό συντήρηση',
  'presence.title': 'Κατάσταση παρουσίας',
  'presence.currentStatus': 'Τρέχουσα κατάσταση:',
  'presence.changeStatus': 'Αλλαγή κατάστασης',
  'presence.status.online': 'Συνδεδεμένος',
  'presence.status.online.title': 'Συνδεδεμένος - Ορατός σε όλους',
  'presence.status.online.description': 'Συνδεδεμένος: Ορατός σε όλες τις επαφές',
  'presence.status.idle': 'Αδρανής',
  'presence.status.idle.title': 'Αδρανής - Υποδεικνύει προσωρινή απουσία',
  'presence.status.idle.description': 'Αδρανής: Υποδεικνύει ότι δεν είστε προσωρινά διαθέσιμος',
  'presence.status.dnd': 'Μην ενοχλείτε',
  'presence.status.dnd.title': 'Μην ενοχλείτε - Υποδεικνύει ότι δεν επιθυμείτε διακοπές',
  'presence.status.dnd.description': 'Μην ενοχλείτε: Ορατή ένδειξη ότι δεν επιθυμείτε διακοπές',
  'presence.status.busy': 'Απασχολημένος',
  'presence.status.busy.title': 'Απασχολημένος - Μη διαθέσιμος',
  'presence.status.busy.description': 'Απασχολημένος: Μη διαθέσιμος',
  'presence.status.offline': 'Εκτός σύνδεσης',
  'presence.status.offline.title': 'Αποσυνδεδεμένος - Εμφάνιση ως offline',
  'presence.status.offline.description': 'Εκτός σύνδεσης: Εμφάνιση ως αποσυνδεδεμένος',
  'presence.status.custom': 'Προσαρμοσμένος',
  'presence.status.custom.title': 'Προσαρμοσμένος - Μοναδική κατάσταση με emoji',
  'presence.status.custom.description': 'Προσαρμοσμένος: Μοναδική κατάσταση με emoji και προαιρετική λήξη',
  'presence.custom.title': 'Προσαρμοσμένη κατάσταση',
  'presence.custom.status': 'Προσαρμοσμένη κατάσταση',
  'presence.custom.placeholder': 'Π.χ.: Πίνω καφέ ☕',
  'presence.custom.emoji': 'Emoji (προαιρετικό)',
  'presence.custom.emojiHelp': 'Επίλεξε emoji ή πληκτρολόγησε ένα',
  'presence.custom.temporary': 'Προσωρινή κατάσταση (λήγει αυτόματα)',
  'presence.custom.expiration': 'Ημερομηνία λήξης',
  'presence.custom.expirationHelp': 'Η κατάσταση θα επιστρέψει σε "Συνδεδεμένος" όταν λήξει',
  'presence.custom.suggestions': 'Προτάσεις',
  'presence.custom.preview': 'Προεπισκόπηση',
  'presence.custom.save': 'Αποθήκευση κατάστασης',
  'presence.custom.required': 'Η προσαρμοσμένη κατάσταση είναι υποχρεωτική',
  'presence.custom.maxLength': 'Μέγιστο 64 χαρακτήρες',
  'presence.custom.expirationRequired': 'Πρέπει να επιλέξετε ημερομηνία λήξης',
  'presence.custom.expirationFuture': 'Η ημερομηνία λήξης πρέπει να είναι στο μέλλον',
  'presence.custom.selectEmoji': 'Επιλογή emoji',
  'home.access_nav': 'Πρόσβαση στην εφαρμογή',
  'plan.free_characters_month': '30.000 χαρακτήρες / μήνα',
  'plan.pro_characters_month': '300.000 χαρακτήρες / μήνα',
  'suggestions.title': 'Προτάσεις',
  'suggestions.form.title': 'Τίτλος πρότασης',
  'suggestions.form.message': 'Περιγράψτε την ιδέα σας',
  'suggestions.form.submit': 'Αποστολή πρότασης',
  'suggestions.send': 'Αποστολή πρότασης',
  'suggestions.captcha_placeholder': 'Αποτέλεσμα',
  'suggestions.cooldown': 'Πρέπει να περιμένετε {minutes} λεπτά πριν στείλετε νέα πρόταση.',
  'suggestions.success_title': 'Η πρόταση στάλθηκε',
  'suggestions.success_message': 'Η πρότασή σας στάλθηκε με επιτυχία. Αριθμός παρακολούθησης: {id}',
  'suggestions.success': 'Ευχαριστούμε για την πρότασή σας. Η ομάδα μας θα την εξετάσει.',
  'suggestions.success.title': 'Ευχαριστούμε για την πρότασή σας!',
  'suggestions.success.reference': 'Αναφορά',
  'suggestions.success.review': 'Η ομάδα μας θα εξετάσει την ιδέα σας.',
  'suggestions.success.email': 'Σας στείλαμε επίσης email επιβεβαίωσης.',
  'suggestions.success.copy': 'Αντιγραφή',
  'suggestions.success.copied': 'Η αναφορά αντιγράφηκε',
  'suggestions.form.required': 'Ο τίτλος και το μήνυμα είναι υποχρεωτικά.',
  'suggestions.error': 'Η αποστολή απέτυχε. Δοκιμάστε ξανά.',
  'suggestions.sendSuccess': 'Η πρότασή σας στάλθηκε με επιτυχία.',
  'suggestions.sendError': 'Δεν ήταν δυνατή η αποστολή της πρότασης. Δοκιμάστε ξανά.',
  'suggestions.sent': 'Η πρόταση στάλθηκε με επιτυχία.',
  'suggestions.new': 'Νέα πρόταση',
  'suggestions.empty': 'Δεν έχετε στείλει ακόμα προτάσεις.',
  'suggestions.admin_note': 'Σημείωση ομάδας',
  'suggestions.status.pending': 'Σε εκκρεμότητα',
  'suggestions.status.reviewed': 'Εξετάστηκε',
  'suggestions.status.planned': 'Προγραμματίστηκε',
  'suggestions.status.implemented': 'Υλοποιήθηκε',
  'suggestions.status.rejected': 'Απορρίφθηκε',
  'errors.suggestionSend': 'Δεν ήταν δυνατή η αποστολή της πρότασης. Δοκιμάστε ξανά.',
  'help.title': 'Βοήθεια ArChat®',
  'help.howWorks.title': 'Πώς λειτουργεί το ArChat®',
  'help.languages.title': 'Γλώσσες',
  'help.languages.point1': 'Υποστήριξη για {count} γλώσσες.',
  'help.languages.point2': 'Οπτικός επιλογέας γλώσσας με σημαίες.',
  'notifications.title': 'Ειδοποιήσεις',
  'notifications.empty': 'Δεν υπάρχουν ειδοποιήσεις',
  'errors.generic': 'Παρουσιάστηκε απρόσμενο σφάλμα.',
  'errors.network': 'Σφάλμα σύνδεσης. Δοκιμάστε ξανά.',
  'errors.required': 'Αυτό το πεδίο είναι υποχρεωτικό.',
  'promotions.invite.message': 'Σας προσκαλώ στο ArChat — μιλήστε σε οποιαδήποτε γλώσσα. Και οι δύο κερδίζουμε οφέλη.',
  'promotions.progress.pending': 'Έχετε προσκλήσεις σε εκκρεμότητα για να ξεκλειδώσετε ανταμοιβές.',
  'promotions.progress.in_progress': 'Οι προσκλήσεις σας βρίσκονται σε εξέλιξη: οι επιβραβεύσεις ενεργοποιούνται μετά από μια πραγματική συνομιλία.',
  'promotions.progress.remaining': 'Χρειάζεστε {count} ακόμη συνομιλία για να λάβετε την ανταμοιβή σας.',
  'promotions.progress.sent_count': 'Στάλθηκε',
  'promotions.progress.pending_count': 'Εκκρεμής',
  'promotions.progress.in_progress_count': 'Σε εξέλιξη',
  'promotions.progress.completed_count': 'Ολοκληρώθηκε το',
  'promotions.banner.empty': 'Ξεκινήστε τώρα: προσκαλέστε επαφές και ξεκλειδώστε τα προνόμια.',
  'promotions.banner.pending': 'Έχετε προσκλήσεις σε εκκρεμότητα: ολοκληρώστε μια πραγματική συνομιλία και κερδίστε ανταμοιβές.',
  'promotions.banner.reward': 'Έχετε ήδη ξεκλειδώσει τις ανταμοιβές! Συνεχίστε να προσκαλείτε για να αυξήσετε τα κέρδη σας.',
  'promotions.cta.copy': 'Αντιγραφή μηνύματος και συνδέσμου',
  'promotions.cta.copied': 'Το μήνυμα αντιγράφηκε',
  'promotions.cta.copy_error': 'Δεν ήταν δυνατή η αντιγραφή του μηνύματος',

  'promotions.title': 'Προσφορές και ανταμοιβές',
  'promotions.subtitle': 'Προσκαλέστε επαφές και ξεκλειδώστε τα οφέλη μέσω πραγματικής χρήσης.',
  'promotions.how_it_works': 'Πώς λειτουργεί',
  'promotions.step1': 'Προσκαλέστε μια επαφή από το προφίλ σας.',
  'promotions.step2': 'Όταν αποδέχονται και συνομιλούν με πραγματική αλληλεπίδραση, επικυρώνεται αυτόματα.',
  'promotions.step3': 'Η ανταμοιβή πιστώνεται και η πρόοδός σας ενημερώνεται.',
  'promotions.rewards.title': 'Ανταμοιβές',
  'promotions.reward.invite': 'Επιβράβευση για κάθε επικυρωμένη παραπομπή.',
  'promotions.reward.milestone': 'Μπόνους για ορόσημα ανάπτυξης.',
  'promotions.reward.ranking': 'Ορατότητα στην κορυφαία κατάταξη κατασκευαστών δικτύου.',
  'promotions.progress.title': 'Η πρόοδός σας',
  'promotions.progress.sent': 'Στάλθηκε',
  'promotions.cta.invite': 'Πρόσκληση επαφής',
  'promotions.banner': 'Ενεργοποίηση προωθήσεων: προσκαλέστε και κερδίστε ανταμοιβές για πραγματική χρήση.',
  'promotions.modal.title': 'Πρόγραμμα προωθήσεων',
  'promotions.modal.body': 'Κερδίστε +10.000 χαρακτήρες ανά επικυρωμένη πρόσκληση.\\nΠροσκαλέστε σήμερα και ξεκλειδώστε ανταμοιβές.',
  'promotions.modal.cta': 'Προβολή προσφορών',
  'login.slogan': 'Συνομιλίες χωρίς σύνορα!',
  'login.username': 'Όνομα χρήστη',
  'login.password': 'Κωδικός πρόσβασης',
  'login.submit': 'Σύνδεση',
  'login.loading': 'Φόρτωση...',
  'login.autoRegister.title': 'Αυτόματη εγγραφή',
  'login.autoRegister.description': 'Αν δεν έχετε λογαριασμό, εισαγάγετε όνομα χρήστη, κωδικό και email. Ο λογαριασμός θα δημιουργηθεί αυτόματα και θα λάβετε σύνδεσμο επιβεβαίωσης μέσω email.',
  'login.forgotPassword': 'Ξεχάσατε τον κωδικό;',
  'login.passwordRecovery.title': 'Ανάκτηση κωδικού',
  'login.passwordRecovery.description': 'Εισαγάγετε το email σας για να λάβετε σύνδεσμο ανάκτησης.',
  "login.passwordRecovery.emailLabel": "E-mail",
  'login.passwordRecovery.emailPlaceholder': 'Εισαγάγετε το email σας',
  'login.passwordRecovery.emailHelp': 'Θα σταλεί σύνδεσμος ανάκτησης στο email σας',
  'login.passwordRecovery.send': 'Αποστολή',
  'login.passwordRecovery.success': 'Στάλθηκε σύνδεσμος ανάκτησης στο email σας. Ελέγξτε τα εισερχόμενα.',
  'login.passwordRecovery.successTitle': 'Στάλθηκε email',
  'login.passwordRecovery.successMessage': 'Σας στείλαμε email με οδηγίες επαναφοράς του κωδικού.\nΕλέγξτε τα εισερχόμενα και το φάκελο ανεπιθύμητης αλληλογραφίας. Ο σύνδεσμος μπορεί να χρειαστεί λίγα λεπτά.',
  'login.passwordRecovery.devExplanation': 'Σε λειτουργία ανάπτυξης το email δεν αποστέλλεται στα εισερχόμενα· αποθηκεύεται για προεπισκόπηση. Χρησιμοποιήστε «Προβολή email» για να δείτε το περιεχόμενο και τον σύνδεσμο.',
  'login.passwordRecovery.devSinkNotice': '⚠️ Λειτουργία ανάπτυξης: Αυτό το email ΔΕΝ στάλθηκε στα εισερχόμενα. Χρησιμοποιήστε «Προβολή email» για να ανοίξετε το μήνυμα και τον σύνδεσμο.',
  'login.passwordRecovery.invalidEmail': 'Εισαγάγετε έγκυρη διεύθυνση email',
  'login.error.invalidPassword': 'Μη έγκυρος κωδικός',
  'auth.require_email': 'Το email απαιτείται για να ολοκληρωθεί η εγγραφή. Εισαγάγετε το email σας.',
  'auth.tenant_mismatch': 'Ο λογαριασμός σας δεν ανήκει σε αυτό το περιβάλλον. Επικοινωνήστε με τον διαχειριστή.',
  'auth.account_blocked': 'Ο λογαριασμός είναι ανενεργός. Εισαγάγετε το email σας για επανενεργοποίηση.',
  'auth.device_limit_reached': 'Συμπληρώθηκε το όριο συσκευών. Αποσυνδεθείτε σε άλλη συσκευή ή αναβαθμίστε το πλάνο σας.',
  'auth.login.device_limit.title': 'Συμπληρώθηκε το όριο συνεδριών ή συσκευών',
  'auth.login.device_limit.body': 'Το πλάνο σας επιτρέπει περιορισμένο αριθμό ενεργών συνεδριών ή συσκευών. Για σύνδεση, αποσυνδεθείτε σε άλλη συσκευή ή κλείστε μια άλλη ενεργή συνεδρία και δοκιμάστε ξανά.',
  'auth.password_incorrect': 'Ο κωδικός πρόσβασης είναι λανθασμένος.',
  'auth.login.password_error_title': 'Λανθασμένος κωδικός',
  'auth.login.password_attempts_hint': 'Έχετε 3 προσπάθειες να εισαγάγετε σωστά τον κωδικό σας. Αν τις υπερβείτε, θα πρέπει να επαναφέρετε τον κωδικό σας.',
  'auth.login.password_attempts_exhausted_title': 'Έφταση στο όριο προσπαθειών',
  'auth.login.password_attempts_exhausted_body': 'Υπερβήκατε τις 3 επιτρεπόμενες προσπάθειες. Για να συνεχίσετε, επαναφέρετε τον κωδικό σας από «Ξεχάσατε τον κωδικό;».',
  'auth.login.go_to_reset_password': 'Μετάβαση στην επαναφορά κωδικού',
  'auth.login.password_remaining_two': 'Απομένουν 2 προσπάθειες.',
  'auth.login.password_remaining_one': 'Απομένει 1 προσπάθεια.',
  'auth.login.password_attempts_locked_inline': 'Συμπληρώθηκε ο μέγιστος αριθμός προσπαθειών. Πρέπει να επαναφέρετε τον κωδικό σας.',
  'auth.account_inactive_email_mismatch': 'Ο λογαριασμός είναι ανενεργός και το email δεν ταιριάζει.',
  'auth.captcha_expired': 'Η επαλήθευσή σας έληξε. Δημιουργήθηκε νέα αυτόματα.',
  'auth.captcha_required': 'Ολοκληρώστε την επαλήθευση ασφαλείας (CAPTCHA).',
  'auth.unauthorized': 'Δεν έχετε δικαίωμα πρόσβασης.',
  'auth.method_not_allowed': 'Μη επιτρεπόμενη μέθοδος.',
  'auth.invalid_data': 'Μη έγκυρα δεδομένα.',
  'auth.credentials_required': 'Απαιτούνται όνομα χρήστη και κωδικός.',
  'auth.csrf_invalid': 'Μη έγκυρη συνεδρία. Φορτώστε ξανά τη σελίδα και δοκιμάστε ξανά.',
  'auth.username_taken': 'Αυτό το όνομα χρήστη είναι ήδη καταχωρημένο. Συνδεθείτε ή επιλέξτε άλλο.',
  'auth.username_unavailable': 'Αυτό το όνομα χρήστη δεν είναι διαθέσιμο.',
  'auth.nick_no_spaces': 'Τα ψευδώνυμα δεν μπορούν να περιέχουν κενά.',
  'auth.password_too_short': 'Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες.',
  'auth.confirm_success': 'Ο λογαριασμός επιβεβαιώθηκε. Ανακατεύθυνση στη σύνδεση...',
  'auth.confirm_already_active': 'Ο λογαριασμός σας είναι ήδη ενεργός. Μπορείτε να συνδεθείτε.',
  'auth.reset_sent': 'Αν το email είναι καταχωρημένο, θα λάβετε οδηγίες επαναφοράς κωδικού.',
  'auth.reset_token_invalid': 'Μη έγκυρος ή ελλιπής σύνδεσμος.',
  'auth.reset_token_expired': 'Αυτός ο σύνδεσμος έληξε. Ζητήστε νέον από «Ξεχάσατε τον κωδικό;».',
  'auth.reset_done': 'Ο κωδικός ενημερώθηκε. Μπορείτε τώρα να συνδεθείτε.',
  'auth.reset_fatal': 'Σφάλμα αποθήκευσης. Δοκιμάστε αργότερα.',
  'resetPassword.page.title': 'Νέος κωδικός',
  'resetPassword.page.description': 'Εισαγάγετε τον νέο κωδικό σας (τουλάχιστον 6 χαρακτήρες).',
  'resetPassword.newPassword': 'Νέος κωδικός',
  'resetPassword.newPasswordPlaceholder': 'Τουλάχιστον 6 χαρακτήρες',
  'resetPassword.submit': 'Επαναφορά κωδικού',
  'resetPassword.success': 'Ο κωδικός ενημερώθηκε. Ανακατεύθυνση στη σύνδεση...',
  'resetPassword.backToLogin': 'Επιστροφή στη σύνδεση',

  'account.delete.section_title': 'Διαγραφή λογαριασμού',
  'account.delete.description': 'Η διαγραφή του λογαριασμού σας θα αφαιρέσει οριστικά όλα τα δεδομένα, μηνύματα, επαφές και ρυθμίσεις. Η ενέργεια δεν μπορεί να αναιρεθεί.',
  'account.delete.button': 'Διαγραφή του λογαριασμού μου',
  'accountDeletion.title': 'Διαγραφή λογαριασμού και δεδομένων',
  'accountDeletion.description': 'Ζητήστε τη διαγραφή του λογαριασμού ArChat και των σχετικών δεδομένων.',
  'accountDeletion.openRequest': 'Αίτηση διαγραφής λογαριασμού και δεδομένων',
  'account.delete.confirm_title': 'Διαγραφή λογαριασμού',
  'account.delete.confirm_message': 'Είστε βέβαιοι ότι θέλετε να διαγράψετε τον λογαριασμό σας; Θα σταλεί email επιβεβαίωσης στα εισερχόμενά σας. Η διαγραφή είναι μόνιμη και μη αναστρέψιμη.',
  'account.delete.email_sent_title': 'Στάλθηκε email',
  'account.delete.email_sent': 'Σας στείλαμε email επιβεβαίωσης. Ελέγξτε τα εισερχόμενα και κάντε κλικ στον σύνδεσμο για να επιβεβαιώσετε τη διαγραφή.',
  'account.delete.error': 'Δεν ήταν δυνατή η επεξεργασία του αιτήματος. Δοκιμάστε ξανά.',
  'account.delete.confirm_page_title': 'Επιβεβαίωση διαγραφής λογαριασμού',
  'account.delete.confirm_page_desc': 'Πρόκειται να διαγράψετε οριστικά τον λογαριασμό ArChat σας. Όλα τα δεδομένα, μηνύματα, επαφές και ρυθμίσεις θα αφαιρεθούν. Η ενέργεια δεν μπορεί να αναιρεθεί.',
  'account.delete.confirm_final_button': 'Ναι, διαγραφή του λογαριασμού μου οριστικά',
  'account.delete.cancel_go_back': 'Ακύρωση και επιστροφή',
  'account.delete.done_title': 'Ο λογαριασμός διαγράφηκε',
  'account.delete.done_message': 'Ο λογαριασμός σας διαγράφηκε επιτυχώς. Όλα τα δεδομένα αφαιρέθηκαν.',
  'account.delete_token_expired': 'Ο σύνδεσμος διαγραφής έληξε ή δεν είναι πλέον έγκυρος. Ζητήστε νέο από το προφίλ σας.',
  'account.delete_token_invalid': 'Μη έγκυρος ή ελλιπής σύνδεσμος διαγραφής.',
  'account.delete_email_failed': 'Δεν ήταν δυνατή η αποστολή email επιβεβαίωσης. Δοκιμάστε αργότερα.',
  'account.delete_error': 'Σφάλμα κατά τη διαγραφή. Δοκιμάστε αργότερα.',

  'mail.send_failed': 'Δεν ήταν δυνατή η αποστολή email ανάκτησης. Ελέγξτε τη διαμόρφωση SMTP ή δοκιμάστε αργότερα.',
  'auth.register_success_email_sent': 'Ο λογαριασμός δημιουργήθηκε επιτυχώς. Στάλθηκε email επιβεβαίωσης. Ελέγξτε τα εισερχόμενα (και ανεπιθύμητα) και κάντε κλικ στον σύνδεσμο για ενεργοποίηση.',
  'auth.register_success_email_pending': 'Ο λογαριασμός δημιουργήθηκε, αλλά υπήρξε πρόβλημα αποστολής email επιβεβαίωσης. Το διακριτικό ενεργοποίησης παραμένει έγκυρο. Επικοινωνήστε με τον διαχειριστή ή ζητήστε νέο email.',
  'auth.email_not_verified': 'Πρέπει να επιβεβαιώσετε το email για να ενεργοποιήσετε τον λογαριασμό.',
  'auth.email_not_verified_title': 'Ο λογαριασμός εκκρεμεί επιβεβαίωση',
  'auth.email_send_failed': 'Δεν ήταν δυνατή η αποστολή του email. Δοκιμάστε ξανά ή αλλάξτε email.',
  'auth.email_send_failed_title': 'Αποτυχία αποστολής email',
  'auth.register.email_failed.title': 'Ο λογαριασμός δημιουργήθηκε',
  'auth.register.email_failed.message': 'Ο λογαριασμός σας δημιουργήθηκε, αλλά υπήρξε πρόβλημα αποστολής email επιβεβαίωσης. Ελέγξτε ανεπιθύμητα ή ζητήστε νέο email.',
  'auth.register.success.title': 'Ο λογαριασμός δημιουργήθηκε',
  'auth.register.success.message': 'Ο λογαριασμός δημιουργήθηκε επιτυχώς. Στάλθηκε email επιβεβαίωσης. Ελέγξτε τα εισερχόμενα (και ανεπιθύμητα) και κάντε κλικ στον σύνδεσμο για ενεργοποίηση.',
  'auth.resend_sent': 'Το email επιβεβαίωσης στάλθηκε ξανά.',
  'auth.resend_activation': 'Επανάληψη αποστολής email ενεργοποίησης',
  'auth.resend_email': 'Επανάληψη αποστολής email',
  'auth.retry_resend': 'Δοκιμάστε ξανά',
  'auth.change_email': 'Αλλαγή email',
  'auth.ver_email': 'Προβολή email',
  'auth.already_verified': 'Ο λογαριασμός είναι ήδη επαληθευμένος.',
  'auth.confirm_email_title': 'Επιβεβαίωση email',
  'auth.confirm_email_text': 'Ο σύνδεσμος ενεργοποίησης θα σταλεί στο:',
  'auth.confirm_email_edit': 'Επεξεργασία',
  'auth.confirm_email_confirm': 'Επιβεβαίωση',
  'auth.confirm_email_typo_hint': 'Μήπως εννοούσατε ***@{suggestion};',
  'brand.slogan': 'Η δύναμη του να σε καταλαβαίνουν, ανεξάρτητα από τη γλώσσα',
  "brand.appName": "ArChat®",
  "brand.name": "ArChat®",
  "home.title": "ArChat®",
  'home.slogan': 'Η δύναμη του να σε καταλαβαίνουν, ανεξάρτητα από τη γλώσσα',
  'home.tagline': 'Μηνύματα με αυτόματη μετάφραση',
  'home.login': 'Σύνδεση',
  'home.register': 'Δημιουργία λογαριασμού',
  'terms.title': 'Όροι και προϋποθέσεις',
  'terms.accept': 'Αποδοχή και συνέχεια',
  'terms.reject': 'Απόρριψη',
  'terms.rejectShort': 'Δεν αποδέχομαι',
  'terms.readAndAccept': 'Έχω διαβάσει και αποδέχομαι τους όρους και τις προϋποθέσεις',
  'terms.cancel': 'Ακύρωση',
  'register.pageSubtitle': 'Εισαγάγετε τα στοιχεία σας για να δημιουργήσετε λογαριασμό.',
  'register.submitLabel': 'Δημιουργία λογαριασμού',
  'register.confirm_title': 'Επιβεβαίωση λογαριασμού',
  'register.confirm_message': 'Πρόκειται να δημιουργήσετε τον λογαριασμό:',
  'register.confirm': 'Επιβεβαίωση',
  'register.creatingAccount': 'Δημιουργία λογαριασμού…',
  'register.login_link': 'Έχετε ήδη λογαριασμό;',
  'register.password_hint': 'Τουλάχιστον 6 χαρακτήρες',
  'register.checking': 'Έλεγχος…',
  'register.username_taken': 'Αυτό το όνομα χρήστη χρησιμοποιείται ήδη.',
  'register.available': 'Διαθέσιμο',
  'register.emailAlreadyExists': 'Αυτό το email είναι ήδη καταχωρημένο.',
  'register.continue': 'Συνέχεια',
  'login.demo.title': 'Πρόσβαση επίδειξης',
  'login.demo.credentials': 'Χρήστης: demo / Κωδικός: demo',
  'login.email.placeholder': 'Εισαγάγετε το email για επιβεβαίωση του λογαριασμού',
  'login.email.help': 'Θα σταλεί σύνδεσμος επιβεβαίωσης στο email σας',
  'app.install_ios_hint': 'Για εγκατάσταση: Κοινοποίηση > Προσθήκη στην αρχική οθόνη',
  'common.edit': 'Επεξεργασία',
  'common.on': 'Ενεργό',
  'common.off': 'Ανενεργό',
  'common.back': 'Πίσω',
  'common.changeUser': 'Αλλαγή χρήστη',
  'common.refresh': 'Ανανέωση',
  'common.request_id_label': 'Αναγνωριστικό αιτήματος',
  'login.email.invalid': 'Εισαγάγετε έγκυρο email',
  'system.processing': 'Επεξεργασία...',
  'captcha.solve': 'Λύστε σωστά το CAPTCHA',
  'captcha.generateError': 'Σφάλμα δημιουργίας CAPTCHA. Φορτώστε ξανά τη σελίδα.',
  'captcha.label': 'Επαλήθευση ασφαλείας',
  'security.verification_title': 'Επαλήθευση ασφαλείας',
  'security.captcha_question': 'Ερώτηση επαλήθευσης',
  'security.enter_answer': 'Εισαγάγετε την απάντηση',
  'captcha.description': 'Λύστε την πράξη για να συνεχίσετε.',
  'captcha.required': 'Πρέπει να εισαγάγετε την απάντηση CAPTCHA για να συνεχίσετε.',
  'captcha.incorrect': 'Η απάντηση CAPTCHA είναι λανθασμένη.',
  'captcha.placeholder': 'Εισαγάγετε την απάντηση',
  'captcha.questionFormat': 'Πόσο κάνει {a} + {b};',
  'menu.conversations': 'Συνομιλίες',
  'menu.admin': 'Διαχείριση',
  'menu.promotions': 'Προσφορές',
  "navbar.profile": "Το προφίλ μου",
  "navbar.settings": "Διαμόρφωση",
  "navbar.logout": "Πάω έξω",
  'navbar.no_blocked_users': 'Δεν υπάρχουν αποκλεισμένοι χρήστες',
  'navbar.blocked_users_title': 'Αποκλεισμένοι χρήστες',
  'contacts.blocked_users_title': 'Αποκλεισμένοι χρήστες',
  'contacts.country_label': 'Χώρα',
  'contacts.not_reported': 'Δεν αναφέρεται',
  "navbar.user_fallback": "Χρήστης {αναγνωριστικό}",
  "navbar.open_guide": "Οδηγός",
  "help.view_initial_guide": "Δείτε τον αρχικό οδηγό",
  "help.how_archat_works": "Πώς λειτουργεί το ArChat®",
  "help.registration": "Ρεκόρ",
  "help.private_invitations": "Ιδιωτικές προσκλήσεις",
  "help.messaging": "Μηνύματα",
  "help.security": "Ασφάλεια",
  "invitation.quick_button": "Πρόσκληση επαφής",
  "onboarding.title": "Καλώς ήρθατε στο ArChat®",
  "onboarding.subtitle": "Επικοινωνήστε με οποιονδήποτε σε οποιαδήποτε γλώσσα.",
  "onboarding.step1.label": "Βήμα 1",
  "onboarding.step1.text": "Προσκαλέστε την πρώτη σας επαφή",
  "onboarding.step2.label": "Βήμα 2",
  "onboarding.step2.text": "Στείλτε το πρώτο σας μήνυμα",
  "onboarding.actions.invite": "Πρόσκληση επαφής",
  "onboarding.actions.explore": "Εξερευνήστε το ArChat®",
  "onboarding.welcome_subtitle": "Επικοινωνήστε με οποιονδήποτε σε οποιαδήποτε γλώσσα.",
  "onboarding.step1": "Βήμα 1",
  "onboarding.step1_title": "Βήμα 1",
  "onboarding.step2": "Βήμα 2",
  "onboarding.step2_title": "Βήμα 2",
  "onboarding.invite_contact": "Πρόσκληση επαφής",
  "referral.promo": "Προσκαλέστε και κερδίστε 10.000 χαρακτήρες",
  "referral.stats.sent": "Στάλθηκε",
  "referral.stats.accepted": "Δεκτός",
  "referral.stats.rewards": "Ανταμοιβές",
  "referral.reward.pending": "Σκουλαρίκι",
  "referral.reward.granted": "Γέμισε",
  "referral.reward.invalid": "Ακυρος",
  "referral.reward.in_progress": "Σε χρήση",
  "referral.limit.reached": "Συμπληρώθηκε το όριο ανταμοιβής",
  "referral.waiting.usage": "+10.000 χαρακτήρες ο καθένας όταν εσείς και ο καλεσμένος σας στέλνετε τουλάχιστον ένα πραγματικό μήνυμα κειμένου στην ίδια συνομιλία (επικυρωμένο από τον διακομιστή).",
  "common.avatar": "Avatar",
  "common.requiredFields": "Συμπληρώστε όλα τα απαιτούμενα πεδία.",
  "bio.view": "Δείτε βιογραφικό",
  "profile.founderBadge": "Ιδρυτής #{position}/{limit}",
  "profile.founderTooltip": "Ιδρυτικό μέλος – Η τιμή έχει παγώσει εφ' όρου ζωής για όσο διάστημα η συνδρομή παραμένει ενεργή",
  "profile.founderMember": "Ιδρυτικό Μέλος",
                'profile.founderHeaderBadge': '★ Ιδρυτής #{position}/150',
                'profile.camera.access_denied': 'Δεν ήταν δυνατή η πρόσβαση στην κάμερα. Ελέγξτε τα δικαιώματα.',
  "profile.save.success": "Το προφίλ σας ενημερώθηκε με επιτυχία.",
  "profile.save.success.title": "Ενημερωμένο προφίλ",
  "profile.update.success.title": "Ενημερωμένο προφίλ",
  "profile.update.success.message": "Οι αλλαγές σας αποθηκεύτηκαν με επιτυχία.",
  "profile.save.error": "Δεν ήταν δυνατή η ενημέρωση του προφίλ. Δοκιμάστε ξανά.",
  "profile.save.error.title": "Αποθήκευση σφάλματος",
  "profile.nick": "Ονομα χρήστη",
  "profile.nick.help": "Το μοναδικό σας αναγνωριστικό στο σύστημα",
  "profile.nick.readonly": "Το όνομα χρήστη δεν μπορεί να τροποποιηθεί",
  "profile.nick.readonly.help": "Το όνομα χρήστη είναι μοναδικό και δεν μπορεί να τροποποιηθεί",
  "profile.email.readonly": "Το email δεν μπορεί να τροποποιηθεί",
  "profile.email.readonly.help": "Το email είναι μοναδικό και δεν μπορεί να τροποποιηθεί",
  "profile.name": "Πραγματικό Όνομα",
  "profile.lastname": "Επώνυμο",
  "profile.alias": "Ψευδώνυμο",
  "profile.email": "E-mail",
  "profile.phone": "Τηλέφωνο",
  "profile.country": "Χώρα",
  "profile.country.select": "Επιλέξτε χώρα",
  "profile.biography": "Βιογραφία",
  'bio.modal.original': 'Πρωτότυπο',
  'bio.modal.translation': 'Μετάφραση',
  'bio.modal.empty': 'Αυτή η επαφή δεν έχει βιογραφία.',
  'bio.modal.translating': 'Μετάφραση...',
  'bio.modal.translation_error': 'Δεν ήταν δυνατή η μετάφραση της βιογραφίας.',
  'attachment.unnamed_file': 'Αρχείο',
  'auth.login_error.default_title': 'Σφάλμα πρόσβασης',
  'auth.login_error.default_message': 'Δεν ήταν δυνατή η σύνδεση.',
  "profile.photo": "Φωτογραφία προφίλ",
                'notifications.bell.aria': 'Ειδοποιήσεις',
                'notifications.panel.title': 'Ειδοποιήσεις',
                'notifications.empty': 'Δεν υπάρχουν ειδοποιήσεις',
                'notifications.mark_read': 'Σήμανση ως αναγνωσμένο κατά το άνοιγμα',
  'profile.notifications.sound': 'Notification sound',
  "profile.notifications.sound_desc": "Αναπαραγωγή ήχου όταν φτάνουν σημαντικά μηνύματα ή ειδοποιήσεις",
  "profile.invitations.title": "Προσκλήσεις",
  "profile.invitations.validated": "Επικυρωμένες προσκλήσεις",
  "profile.invitations.nextBadge": "Επόμενο επίτευγμα",
  "profile.invitations.progress": "Πρόοδος",
  "profile.invitations.achievement": "Κατόρθωμα",
  "profile.invitations.topInviterAchieved": "Συμπληρώθηκε ο μέγιστος προσκλητής",
  "profile.invitations.badges.networkBuilder": "Εργαλείο δημιουργίας δικτύου",
  "profile.invitations.badges.topInviter": "Μέγιστος προσκλητής",
  "profile.invitations.achievement.networkBuilderMessage": "Προσκαλέσατε 20 χρήστες στο ArChat.",
  "profile.invitations.achievement.topInviterMessage": "Προσκαλέσατε 50 χρήστες στο ArChat.",
  "profile.plan.title": "Πρόγραμμα συνδρομής",
  "profile.plan.current": "Το τρέχον σας σχέδιο",
  "profile.plan.expires": "λήγει",
  "profile.plan.loading_info": "Φόρτωση πληροφοριών σχεδίου...",
  "profile.plan.valid_until": "Ισχύει έως:",
  "profile.plan.active_since": "Ενεργός από:",
  "profile.plan.active_badge": "✓ Ενεργός",
  'profile.plan.free.description': 'Free plan with limitations. Upgrade to PRO for full access.',
  'profile.plan.pro.description': 'You have full access to all features.',
  "profile.plan.upgrade.button": "Αναβάθμιση σε PRO",
  'profile.plan.upgrade.hint': 'Access all features without limits',
  "profile.manage_plan": "Διαχείριση σχεδίου",
  "plan.current_plan": "Τρέχον σχέδιο",
  "plan.current": "Actual",
  'plan.footer_prefix': 'Πλάνο:',
  "plan.upgrade_to_pro": "Αναβάθμιση σε PRO",
  "plan.upgrade_to_foundation": "Αναβάθμιση σε FOUNDATION",
  "plan.payment_coming": "Η πληρωμή με το Paddle θα είναι διαθέσιμη σύντομα. Μπορείτε να αλλάξετε σχέδια από εδώ.",
  "plan.payment_coming_title": "Σύντομα",
  "plan.foundation_full": "Η ποσόστωση FOUNDATION είναι πλήρης (150 ιδρυτές). Μπορείτε να επιλέξετε PRO.",
  "plan.sold_out": "Εξαντλημένος",
  "plan.founder_spots_remaining": "Μόνο {count} διαθέσιμες θέσεις",
  "plan.founders_occupied": "πολυάσχολοι ιδρυτές",
  "plan.upgrade_not_allowed": "Μόνο οι χρήστες με ΔΩΡΕΑΝ πρόγραμμα μπορούν να ζητήσουν αναβάθμιση.",
  'plan.free_contacts': 'Έως 2 επαφές',
  "plan.free_no_files": "Sin archivos",
  "plan.free_retention": "Historial 30 días",
  "plan.pro_files": "Archivos hasta 50MB",
  "plan.pro_export": "Exportación",
  "plan.founder_support": "Prioridad soporte",
  "plan.founder_badge": "Badge fundador",
  "founder.title": "ΙΔΡΥΜΑ (Ιδρυτής)",
  "founder.subtitle": "Υποστηρίζετε το έργο από την αρχή με τίμημα ζωής.",
  "founder.whatIs": "Οι πρώτοι 150 χρήστες λαμβάνουν το πρόγραμμα FOUNDATION σε μειωμένη τιμή εφ' όρου ζωής.",
  "founder.howItWorks": "Το επίπεδο ιδρυτή σας εξαρτάται από τη θέση σας (1 έως 150).",
  "founder.benefitsTitle": "Οφέλη",
  'founder.benefitPrice': '$15 / μήνα (τιμή Founder)',
  "founder.benefitFeatures": "Περιλαμβάνει όλες τις δυνατότητες του προγράμματος PRO.",
  "founder.limit": "Υπάρχουν μόνο 150 θέσεις Ιδρυτών.",
  "founder.cancelRule": "Εάν ακυρώσετε, χάνετε την κατάσταση Ιδρυτή ενώ είστε διαγραφείς.",
  "founder.rejoinRule": "Εάν υπάρχει ξανά διαθέσιμος χώρος, μπορείτε να τον ενεργοποιήσετε ξανά και να γίνετε ξανά αυτόματα Ιδρυτής.",
  "founder.tiers.title": "Ιδρυτικά επίπεδα",
  "founder.tiers.legendary.name": "ΘΡΥΛΙΚΟΣ Ιδρυτής",
  "founder.tiers.legendary.range": "Θέση 1–25",
  "founder.tiers.legendary.desc": "Ο πρώτος που υποστήριξε το έργο. Μέγιστη ιστορική προτεραιότητα.",
  "founder.tiers.early.name": "EARLY Ιδρυτής",
  "founder.tiers.early.range": "Θέση 26–75",
  "founder.tiers.early.desc": "Έγκαιρη υποστήριξη με ειδική αναγνώριση.",
  "founder.tiers.founder.name": "ιδρυτής",
  "founder.tiers.founder.range": "Θέση 76–150",
  "founder.tiers.founder.desc": "Ποσόστωση ιδρυτών εντός 150 θέσεων.",
  "founder.whatIsLink": "Τι είναι το Founder;",
  "founder.viewTiers": "Δείτε τα επίπεδα ιδρυτών",
  'billing.change_plan': 'Αλλαγή πλάνου',
  "billing.usage.title": "Σχέδιο χρήσης",
  "billing.usage.users": "Χρήστες",
  "billing.usage.messages": "Μηνύματα (σήμερα)",
  "billing.usage.invitations": "Προσκλήσεις (σήμερα)",
  "billing.usage.messages_month": "Μηνύματα αυτόν τον μήνα",
  "billing.usage.chats": "συνομιλίες",
  "billing.usage.contacts": "Επαφές",
  "billing.usage.chars_month": "Χαρακτήρες ανά μήνα",
  "billing.usage.storage": "Μεταχειρισμένος αποθηκευτικός χώρος",
  "billing.usage.devices": "Συνδεδεμένες συσκευές",
  'billing.usage.warning': 'You are approaching your plan limit. Upgrade to PRO for more capacity.',
  'plans.limit.reached': 'Το όριο έφτασε — Αναβάθμιση πλάνου',
  "billing.loading": "Φόρτιση...",
  'billing.subscription.section_title': 'Συνδρομή και χρέωση',
  'billing.subscription.provider_note': 'Πάροχος',
  'billing.subscription.paddle_active': 'Paddle (ενεργό πλάνο στην εφαρμογή)',
  'billing.subscription.mp_action_ok': 'Η αίτηση καταγράφηκε. Αν δεν άνοιξε το checkout, ελέγξτε τη σύνδεση ή δοκιμάστε ξανά.',
  'billing.paddle.manage_subscription_button': 'Διαχείριση συνδρομής',
  'billing.paddle.portal_confirm_title': 'Πύλη χρέωσης',
  'billing.paddle.portal_confirm': 'Θα ανοίξει η ασφαλής πύλη Paddle για ενημέρωση πληρωμής, τιμολογίων ή ακύρωση συνδρομής. Συνέχεια;',
  'billing.paddle.portal_opened_hint': 'Η πύλη Paddle άνοιξε σε νέα καρτέλα. Ανανεώστε το προφίλ αν το πλάνο δεν ενημερώθηκε.',
  'billing.paddle.portal_error': 'Δεν ήταν δυνατό το άνοιγμα της πύλης Paddle. Δοκιμάστε αργότερα ή επικοινωνήστε με την υποστήριξη.',
  'billing.paddle.no_link_error': 'Δεν υπάρχει ακόμη σύνδεση συνδρομής Paddle στον λογαριασμό σας. Αν μόλις πληρώσατε, περιμένετε το webhook ή επικοινωνήστε με την υποστήριξη.',
  'billing.paddle.api_not_configured': 'Ο διακομιστής δεν έχει ρύθμιση Paddle API (PADDLE_API_KEY). Πρέπει να την ορίσει ο διαχειριστής.',
  "billing.descriptions.contacts": "Σύνολο επαφών που είναι αποθηκευμένες στον λογαριασμό σας",
  "billing.descriptions.storage": "Αποθηκευτικός χώρος που χρησιμοποιείται για αρχεία και πολυμέσα",
  "billing.descriptions.chars_month": "Μεταφρασμένοι χαρακτήρες αυτόν τον μήνα",
  "billing.descriptions.devices": "Ενεργές συνδεδεμένες συσκευές",
  'billing.paddle.return_title': 'Η πληρωμή ελήφθη',
  'billing.paddle.return_body': 'Αν ολοκληρώσατε το checkout, το πλάνο θα ενημερωθεί σύντομα μετά την επιβεβαίωση από την Paddle. Μπορείτε να επιστρέψτε στην αρχική.',
  'billing.paddle.verifying': 'Έλεγχος πλάνου…',
  'billing.paddle.not_logged_in': 'Συνδεθείτε για να δείτε την ενημερωμένη κατάσταση πλάνου.',
  'billing.paddle.plan_updated': 'Το πλάνο ενημερώθηκε: {plan}',
  'billing.paddle.plan_current': 'Τρέχον πλάνο: {plan}',
  'billing.paddle.plan_current_founder': 'Είστε πλέον Founder — {plan}',
  'billing.paddle.still_free_hint': 'Αν βλέπετε ακόμα FREE μετά από λίγο, το webhook μπορεί να καθυστερεί. Ελέγξτε τα logs ή ανανεώστε τη σελίδα.',
  'billing.paddle.pro_extra_hint': 'Μπορείτε να επιστρέψτε στην αρχική για να χρησιμοποιήσετε το πλάνο σας.',
  "profile.theme.dark": "Σκοτεινή λειτουργία",
  "profile.theme.light": "Εκκαθάριση Λειτουργία",
  "profile.theme.argentina": "Θέμα Αργεντινή",
  "modal.title": "Προσόν",
  "modal.success.title": "Επιτυχία",
  "modal.error.title": "Λάθος",
  "modal.warning.title": "Προειδοποίηση",
  "info.title": "Πληροφορίες",
  "appearance.title": "Εμφάνιση",
  "appearance.theme.light": "Σαφής",
  "appearance.theme.dark": "Σκοτάδι",
  "theme.title": "Ζήτημα",
  "theme.light": "Σαφής",
  "theme.dark": "Σκοτάδι",
  "profile.photo.section": "Φωτογραφία προφίλ",
  "profile.personalInfo": "Προσωπικές Πληροφορίες",
  "profile.preferences": "Προτιμήσεις",
  "profile.country.help": "Η ζώνη ώρας θα εκχωρηθεί αυτόματα με βάση την επιλεγμένη χώρα",
  "profile.lastname.placeholder": "Το επώνυμό σας (προαιρετικό)",
  "profile.name.placeholder": "Το πραγματικό σας όνομα (προαιρετικό)",
  "profile.biography.placeholder": "Πες μας για σένα...",
  "profile.photo.change": "Αλλαγή φωτογραφίας προφίλ",
  "message.placeholder": "Γράψε ένα μήνυμα...",
  "message.placeholderWithFile": "Αποστολή αρχείου",
  "message.sent_from_country": "Στάλθηκε από",
  "message.sent_at_local_time": "Τοπική ώρα του εκδότη",
  "message.timezone_label": "ζώνη ώρας",
  "message.context_info": "Αυτό το μήνυμα διατηρεί το χρονικό πλαίσιο της ώρας που στάλθηκε.",
  "message.context_pro_hint": "Αυτό το μήνυμα έχει χρόνο και γεωγραφικό πλαίσιο διαθέσιμο στα σχέδια Pro.",
  "message.context_pro_badge": "Context Pro",
  "messages.empty": "Δεν υπάρχουν ακόμα μηνύματα",
  "messages.loading": "Φόρτωση μηνυμάτων...",
  "messages.connecting_server": "Σύνδεση στον διακομιστή μηνυμάτων...",
  "messages.pending_send_count": "{count} μηνύματα σε αναμονή παράδοσης",
  "attachment.title": "Επισύναψη αρχείου",
  "attachment.close": "Κοντά",
  "attachment.gallery": "Συλλογή φωτογραφιών/βίντεο",
  "attachment.cameraFront": "μπροστινή κάμερα",
  "attachment.cameraBack": "πίσω κάμερα",
  "attachment.cameraWeb": "κάμερα web",
  "attachment.selectFile": "Επιλογή αρχείου (PDF, κείμενο, εικόνες, βίντεο)",
  "attachment.remove": "Εξαλείφω",
  'attachments.recipientFreeBlocked.title': 'Όριο πλάνου',
  'attachments.recipientFreeBlocked.sender': 'Ο χρήστης έχει πρόγραμμα Free και δεν μπορεί να λάβει συνημμένα.',
  'attachments.recipientFreeBlocked.receiver': 'Ο/Η {senderName} προσπάθησε να σας στείλει συνημμένο, αλλά το πρόγραμμα {planName} δεν επιτρέπει συνημμένα. Προτείνουμε αναβάθμιση για λήψη αρχείων.',
  'attachments.recipientFreeBlocked.upgradeCta': 'Αναβάθμιση πλάνου',
  "attachment.audioNotSupported": "Τα ηχητικά μηνύματα δεν υποστηρίζονται στο ArChat®. Παρακαλώ στείλτε γραπτό μήνυμα.",
  "message.audioDeprecated.title": "Το φωνητικό μήνυμα δεν υποστηρίζεται",
  "message.audioDeprecated.message": "Αυτό το φωνητικό μήνυμα δεν υποστηρίζεται πλέον από το ArChat®. Παρακαλώ στείλτε γραπτό μήνυμα.",
  "camera.title": "Κάμερα",
  "camera.close": "Κοντά",
  "camera.switch": "Αλλαγή κάμερας",
  "camera.capture": "Τραβήξτε φωτογραφία",
  "camera.loading": "Εκκίνηση κάμερας...",
  "camera.retry": "Δοκιμάζω πάλι",
  "camera.error.access": "Δεν ήταν δυνατή η πρόσβαση στην κάμερα. Ελέγξτε τις άδειες.",
  "camera.error.permission": "Τα δικαιώματα κάμερας απορρίφθηκαν. Επιτρέψτε την πρόσβαση στην κάμερα στις ρυθμίσεις του προγράμματος περιήγησής σας.",
  "camera.error.notFound": "Δεν βρέθηκε διαθέσιμη κάμερα.",
  "camera.error.busy": "Η κάμερα χρησιμοποιείται από άλλη εφαρμογή.",
  "camera.error.constraint": "Οι περιορισμοί της κάμερας δεν μπορούν να ικανοποιηθούν.",
  "profile.photo.take": "Τραβήξτε φωτογραφία",
  "profile.photo.gallery": "Επιλέξτε από τη συλλογή",
  "profile.photo.select": "Επιλέξτε φωτογραφία",
  "profile.photo.select.gallery": "Επιλέξτε από τη συλλογή",
  "profile.photo.uploading": "Μεταφόρτωση εικόνας...",
  "profile.photo.upload.success": "Η φωτογραφία προφίλ ενημερώθηκε με επιτυχία",
  "profile.photo.upload.success.title": "Ενημερωμένη φωτογραφία",
  "profile.photo.upload.error": "Σφάλμα μεταφόρτωσης φωτογραφίας προφίλ. Δοκιμάστε ξανά.",
  "profile.photo.upload.error.title": "Σφάλμα κατά τη μεταφόρτωση φωτογραφίας",
  "avatar.errors.too_large": "Η εικόνα είναι πολύ μεγάλη. Μέγιστο μέγεθος: 2 MB.",
  "avatar.preview.title": "Προεπισκόπηση Avatar",
  "profile.avatar.error_title": "Δεν ήταν δυνατή η ενημέρωση του avatar",
  "profile.avatar.error.title": "Δεν ήταν δυνατή η ενημέρωση του avatar",
  "profile.avatar.error.size": "Η εικόνα υπερβαίνει το επιτρεπόμενο μέγεθος. Το μέγιστο είναι 2 MB.",
  "profile.avatar.tooLarge.title": "Η εικόνα είναι πολύ μεγάλη",
  "profile.avatar.tooLarge.message": "Η φωτογραφία υπερβαίνει το επιτρεπόμενο μέγεθος. Το μέγιστο είναι 2 MB.",
  "profile.avatar.uploadError.title": "Δεν ήταν δυνατή η ενημέρωση του avatar",
  "profile.avatar.uploadError.message": "Παρουσιάστηκε πρόβλημα κατά τη μεταφόρτωση της εικόνας. Προσπαθήστε ξανά.",
  "profile.saveSuccess.title": "Ενημερωμένο προφίλ",
  "profile.saveSuccess.message": "Οι αλλαγές σας αποθηκεύτηκαν με επιτυχία.",
  "profile.avatar.file_too_large": "Η εικόνα υπερβαίνει το μέγιστο επιτρεπόμενο μέγεθος (2 MB).",
  "profile.avatar.file_too_large_hint": "Επιλέξτε μια πιο φωτεινή εικόνα ή μειώστε το μέγεθός της και δοκιμάστε ξανά.",
  "profile.photo.take.front": "μπροστινή κάμερα",
  "profile.photo.take.back": "πίσω κάμερα",
  "profile.photo.take.webcam": "κάμερα web",
  "profile.photo.camera.front": "μπροστινή κάμερα",
  "profile.photo.camera.back": "πίσω κάμερα",
  "profile.photo.camera.web": "κάμερα web",
  "profile.photo.close": "Κοντά",
  "profile.photo.capture": "Σύλληψη",
  "user.default": "Μεταχειριζόμενος",
  "logout.title": "Επιβεβαιώνω",
  "logout.confirm": "Είστε βέβαιοι ότι θέλετε να αποσυνδεθείτε;",
  "block.toggle_error": "Δεν ήταν δυνατό το κλείδωμα ή το ξεκλείδωμα.",
  "contacts.search.placeholder": "Αναζήτηση με όνομα χρήστη, όνομα, επώνυμο, χώρα ή γλώσσα...",
  "contacts.empty": "Δεν υπάρχουν επαφές",
  "contacts.empty.private.message": "Το προφίλ σας είναι ιδιωτικό. Προσκαλέστε τις επαφές για να ξεκινήσετε τη συνομιλία.",
  "contacts.empty.private.invite_button": "Προσκαλέστε μια επαφή",
  "contacts.search.no_results": "Δεν βρέθηκαν επαφές",
  "contacts.search.clear": "Εμφάνιση όλων",
  "contacts.nick": "Ονομα χρήστη",
  "contacts.name": "Ονομα",
  "contacts.lastname": "Επώνυμο",
  "contacts.country": "Χώρα",
  "contacts.language": "Γλώσσα",
  "contacts.status.pending_registration": "Η εγγραφή εκκρεμεί",
  "contacts.status.registered": "Επισκέπτης - Εγγεγραμμένος",
  "contacts.status.ready_to_chat": "Έτοιμοι για συνομιλία",
  "contacts.status.active_conversation": "Ενεργή συνομιλία",
  "contacts.invitation.pending.title": "Πρόσκληση σε εκκρεμότητα",
  "contacts.invitation.pending.message": "Αυτή η πρόσκληση εκκρεμεί εγγραφή. Η επαφή θα λάβει ένα email για να ολοκληρώσει την εγγραφή της. Μόλις εγγραφείτε, θα μπορείτε να συνομιλήσετε μαζί του.",
  "contacts.error.no_registered": "Η επαφή δεν έχει καταχωρηθεί ακόμα. Περιμένετε να ολοκληρωθεί η εγγραφή σας.",
  "contact.edit.title": "Επεξεργασία επαφής",
  "contact.edit.alias.label": "Προσαρμοσμένο ψευδώνυμο",
  "contact.edit.alias.placeholder": "Π.χ.: Ο Χουάν από τη δουλειά",
  "contact.edit.alias.help": "Αυτό το όνομα θα εμφανίζεται αντί για το πραγματικό όνομα",
  "contact.edit.nota.label": "Προσωπική σημείωση",
  "contact.edit.nota.placeholder": "Προσθέστε μια σημείωση σχετικά με αυτήν την επαφή...",
  "contact.edit.nota.help": "Οι ιδιωτικές σημειώσεις είναι ορατές μόνο σε εσάς",
  "contact.edit.error.noUser": "Σφάλμα: Μη αναγνωρισμένος χρήστης",
  "contact.edit.error.noContactId": "Σφάλμα: Δεν ήταν δυνατός ο εντοπισμός της επαφής",
  "contact.edit.error.save": "Σφάλμα αποθήκευσης",
  "contact.limit.title": "Συμπληρώθηκε το όριο επικοινωνίας",
  "contact.limit.message": "Το ΔΩΡΕΑΝ πρόγραμμα επιτρέπει έως και 2 επαφές ανά χρήστη. Μπορείτε να κάνετε αναβάθμιση σε FOUNDATION ή PRO για μεγαλύτερη χωρητικότητα όταν είναι ενεργοποιημένη η φόρτιση.",
  "contact.favorite.add": "Προσθήκη στα αγαπημένα",
  "contact.favorite.remove": "Αφαίρεση από τα αγαπημένα",
  "contact.block.block": "Φραγμός",
  'contact.block.unblock': 'Κατάργηση αποκλεισμού',
  "conversation.backToContacts": "Επιστροφή στις επαφές",
  "conversation.notFound": "Η συνομιλία δεν βρέθηκε",
  "help.howWorks.step1.title": "1️⃣ Εγγραφή",
  "help.howWorks.step1.point1": "Συνδεθείτε με το ψευδώνυμο και τον κωδικό πρόσβασής σας.",
  "help.howWorks.step1.point2": "Εάν δεν έχετε λογαριασμό, δημιουργείται αυτόματα.",
  "help.howWorks.step1.point3": "Αποδέχεστε τους Όρους και τις Προϋποθέσεις στη γλώσσα σας.",
  "help.howWorks.step1.point4": "Επιβεβαιώνεις τον λογαριασμό σου μέσω email.",
  "help.howWorks.step2.title": "2️⃣ Ιδιωτικές προσκλήσεις",
  "help.howWorks.step2.point1": "Προσκαλέστε επαφές μέσω email από το προφίλ σας.",
  "help.howWorks.step2.point2": "Καθορίστε τη γλώσσα και τη λειτουργία συνομιλίας πριν ξεκινήσετε.",
  "help.howWorks.step2.point3": "Η επαφή λαμβάνει μια ιδιωτική πρόσκληση.",
  "help.howWorks.step2.point4": "Μπορείτε να δείτε αν είναι: Σε εκκρεμότητα, Εγγεγραμμένο, Έτοιμο για συνομιλία",
  "help.howWorks.step2.point5": "Δεν αναζητούνται επαφές, προσκαλούνται.",
  "help.howWorks.step2.point6": "Δεν αναζητούνται επαφές, προσκαλούνται.",
  "help.howWorks.step3.title": "3️⃣ Επαφές και συνομιλίες",
  "help.howWorks.step3.point1": "Οι επαφές σας εμφανίζονται αυτόματα όταν:",
  "help.howWorks.step3.point2": "αποδεχτείτε μια πρόσκληση",
  "help.howWorks.step3.point3": "ή γίνεται συζήτηση",
  "help.howWorks.step3.point4": "Κουτί:",
  "help.howWorks.step3.point5": "σημειώστε τα ως αγαπημένα ⭐",
  "help.howWorks.step3.point6": "αντιστοιχίστε τους προσαρμοσμένα ψευδώνυμα",
  "help.howWorks.step3.point7": "προσθέστε ιδιωτικές σημειώσεις",
  "help.howWorks.step3.point8": "να τα αποκλείσετε ή να τα διαχειριστείτε",
  "help.howWorks.step3.point9": "Δεν υπάρχει δημόσια ατζέντα ή ορατοί χρήστες χωρίς συγκατάθεση.",
  "help.howWorks.step4.title": "4️⃣ Μηνύματα με μετάφραση",
  "help.howWorks.step4.point1": "Να γράφετε πάντα στη γλώσσα σας.",
  "help.howWorks.step4.point2": "Το σύστημα μεταφράζει αυτόματα το μήνυμα.",
  "help.howWorks.step4.point3": "Ο παραλήπτης το λαμβάνει στη γλώσσα του.",
  "help.howWorks.step4.point4": "Μπορείτε να δείτε την εφαρμογή της μετάφρασης.",
  "help.howWorks.step4.point5": "Εάν μια μετάφραση αποτύχει, επαναλαμβάνεται αυτόματα.",
  "help.howWorks.step4.point6": "Το ArChat® δίνει προτεραιότητα στη σαφήνεια και το νόημα, όχι μόνο στην ταχύτητα.",
  "help.privacy.title": "🔒 Απόρρητο και έλεγχος",
  "help.privacy.point1": "Το προφίλ σας είναι ιδιωτικό από προεπιλογή.",
  "help.privacy.point2": "Μόνο όσοι προσκαλείτε μπορούν να δουν ή να σας γράψουν.",
  "help.privacy.point3": "Η δημόσια ορατότητα είναι προαιρετική και απενεργοποιημένη από προεπιλογή.",
  "help.privacy.point4": "Ενεργητική ασφάλεια με:",
  "help.privacy.point5": "CAPTCHA",
  "help.privacy.point6": "περιορισμός ποσοστού",
  "help.privacy.point7": "δακτυλικό αποτύπωμα",
  "help.privacy.point8": "επαλήθευση email",
  "help.privacy.point9": "Οι συνομιλίες σας δεν είναι δημόσιες ούτε ευρετηριασμένες.",
  "help.files.title": "📎 Αρχεία και εξαγωγή",
  "help.files.point1": "Επισυνάψτε εικόνες, βίντεο και έγγραφα PDF.",
  "help.files.point2": "Τραβήξτε φωτογραφίες με μπροστινή κάμερα, πίσω κάμερα ή webcam.",
  "help.files.point3": "Οι εικόνες συμπιέζονται αυτόματα.",
  "help.files.point4": "Προεπισκόπηση πριν την αποστολή.",
  "help.files.point5": "Γραμμή προόδου κατά τη φόρτωση.",
  "help.files.point6": "Εξαγωγή ολόκληρων συνομιλιών σε:",
  "help.files.point7": "PDF",
  "help.files.point8": "Html",
  "help.files.point9": "Περιλαμβάνει μηνύματα, εικόνες και αρχεία.",
  "help.files.point10": "Τα δεδομένα σας είναι δικά σας.",
  "help.experience.title": "🎨 Εμπειρία χρήστη",
  "help.experience.point1": "Καταστάσεις παρουσίας και προσαρμοσμένες καταστάσεις με emoji.",
  "help.experience.point2": "Ενσωματωμένα emojis OpenMoji.",
  "help.experience.point3": "Ενδείξεις ανάγνωσης και εγγραφής.",
  "help.experience.point4": "Βελτιστοποιημένη προβολή για φορητές συσκευές ίση με την επιφάνεια εργασίας.",
  "help.experience.point5": "Εγκαταστάσιμη εφαρμογή PWA.",
  "help.experience.point6": "Δύο θέματα: Αργεντινή (γαλάζιο/λευκό/χρυσό) και Oscuro (βαθύ μωβ).",
  "help.experience.point7": "Επεξεργασία προφίλ χωρίς αναψυκτικά.",
  "help.experience.point8": "Επιλογέας χώρας με αυτόματη ζώνη ώρας.",
  "help.experience.point9": "Γρήγορη πρόσβαση με αγαπημένα, αναζήτηση και φίλτρα.",
  "help.languages.point3": "Διασύνδεση, T&C και email προσαρμοσμένα στην επιλεγμένη γλώσσα.",
  "help.languages.point4": "Αμφίδρομη αυτόματη μετάφραση μεταξύ των χρηστών.",
  "help.tipsNew.title": "💡 Συμβουλές για να επωφεληθείτε από το ArChat®",
  "help.tipsNew.point1": "Προσκαλέστε μόνο άτομα με τα οποία θέλετε πραγματικά να επικοινωνήσετε.",
  "help.tipsNew.point2": "Χρησιμοποιήστε ψευδώνυμα και ιδιωτικές σημειώσεις για να οργανώσετε τις επαφές.",
  "help.tipsNew.point3": "Επισημάνετε τα αγαπημένα για γρήγορη πρόσβαση.",
  "help.tipsNew.point4": "Ελέγξτε τη μετάφραση πριν στείλετε σημαντικά μηνύματα.",
  "help.tipsNew.point5": "Εξαγωγή σχετικών συνομιλιών για δημιουργία αντιγράφων ασφαλείας ή εργασία.",
  "help.tipsNew.point6": "Χρησιμοποιήστε το ArChat® όταν η γραπτή σαφήνεια είναι το κλειδί.",
  "help.whySubscribe.title": "🚀 Γιατί να εγγραφείτε στο ArChat®",
  "help.whySubscribe.point1": "Το ArChat® δεν έχει σχεδιαστεί για να συνομιλεί με οποιονδήποτε,",
  "help.whySubscribe.point2": "αλλά να επικοινωνώ καλύτερα με αυτούς που έχουν σημασία.",
  "help.whySubscribe.point3": "Εάν χρειάζεστε:",
  "help.whySubscribe.point4": "σαφήνεια μεταξύ των γλωσσών",
  "help.whySubscribe.point5": "πραγματική ιδιωτικότητα",
  "help.whySubscribe.point6": "έλεγχος επαφής",
  "help.whySubscribe.point7": "εξαγωγή συνομιλίας",
  "help.whySubscribe.point8": "μια επαγγελματική και χωρίς θόρυβο εμπειρία",
  "help.whySubscribe.point9": "Το ArChat® έχει σχεδιαστεί για αυτό.",
  "help.how.step1.description": "Χρησιμοποιήστε το ψευδώνυμο και τον κωδικό πρόσβασής σας για πρόσβαση. Εάν δεν έχετε λογαριασμό, δημιουργείται αυτόματα.",
  "help.how.step2.title": "Προσκαλέστε την επαφή σας",
  "help.how.step2.description": "Προσκαλέστε μέσω email από το προφίλ σας και ορίστε τη γλώσσα και τον τρόπο συνομιλίας.",
  "help.how.step3.title": "Γράψτε στη γλώσσα σας",
  "help.how.step3.description": "Γράψτε στη γλώσσα που προτιμάτε και το ArChat® μεταφράζει αυτόματα το μήνυμα.",
  "help.how.step4.title": "Ο δέκτης το λαμβάνει μεταφρασμένο",
  "help.how.step4.description": "Το άλλο άτομο λαμβάνει το μήνυμα μεταφρασμένο στη γλώσσα του με περιεχόμενο και σαφήνεια.",
  "help.features.title": "Κύρια χαρακτηριστικά",
  "help.features.translation": "🌐 Αυτόματη και άμεση μετάφραση μεταξύ γλωσσών",
  "help.features.status": "💬 Καταστάσεις παρουσίας (Online, Idle, Do Not Disturb, κ.λπ.)",
  "help.features.statusCustom": "💬 Προσαρμοσμένες καταστάσεις με emoji και εξατομικευμένο μήνυμα",
  "help.features.contacts": "👥 Πλήρης λίστα επαφών με καρφιτσωμένα αγαπημένα (επάνω) και μπλοκ με δυνατότητα διαχείρισης από το Users Modal",
  "help.features.contactsMobile": "📱 Βελτιστοποιημένη προβολή για κινητά με κατάσταση και εμφάνιση στην επάνω γραμμή (ίδιο με τον υπολογιστή)",
  "help.features.contactsFilter": "👁️ Κουμπί εμφάνισης/απόκρυψης μη αγαπημένων επαφών - μειώστε τη λίστα μόνο στα αγαπημένα σας",
  "help.features.contactAlias": "✏️ Προσαρμοσμένο ψευδώνυμο και ιδιωτικές σημειώσεις για κάθε επαφή - κάντε κλικ στο όνομα της επαφής στη συνομιλία",
  "help.features.themes": "🎨 Δύο θέματα διαθέσιμα: Αργεντινή (ανοιχτό μπλε/λευκό/χρυσό) και Oscuro (βαθύ μωβ)",
  "help.features.messages": "📨 Μηνύματα σε πραγματικό χρόνο με δείκτες ανάγνωσης, ενσωματωμένα emoji OpenMoji και ορατή πληκτρολόγηση",
  "help.features.attachments": "📎 Επισυνάψτε αρχεία συμβατά με γραπτή επικοινωνία: εικόνες, βίντεο και έγγραφα PDF",
  "help.features.camera": "📸 Τραβήξτε φωτογραφίες με μπροστινή, πίσω ή κάμερα web",
  "help.features.gallery": "🖼️ Επιλογή αρχείων από τη συλλογή",
  "help.features.compression": "🗜️ Αυτόματη συμπίεση εικόνας και δημιουργία μικρογραφιών",
  "help.features.progress": "📊 Γραμμή προόδου κατά τη μεταφόρτωση αρχείων",
  "help.features.delete": "🗑️ Διαγραφή δικών μηνυμάτων",
  "help.features.scroll": "⬇️ Αυτόματη κύλιση στο τελευταίο μήνυμα κατά το άνοιγμα μιας συνομιλίας",
  "help.features.profile": "👤 Προσαρμόσιμο προφίλ με avatar, βιογραφία και προτιμήσεις",
  "help.features.profileEdit": "✏️ Απρόσκοπτη επεξεργασία προφίλ (δεν ανανεώνεται κατά την επεξεργασία)",
  "help.features.countries": "🌍 Πλήρης λίστα με 195+ χώρες με αυτόματη επιλογή ζώνης ώρας",
  "help.features.registration": "📧 Εγγραφή με υποχρεωτικούς Όρους και Προϋποθέσεις πριν από τη δημιουργία λογαριασμού και επιβεβαίωση μέσω email",
  "help.features.multilanguage": "🗣️ Υποστήριξη για {count} γλώσσες με σημαίες. T&C και email μεταφρασμένα στην επιλεγμένη γλώσσα",
  "help.features.pwa": "📲 Εφαρμογή PWA με δυνατότητα εγκατάστασης σε κινητές συσκευές και επιτραπέζιους υπολογιστές",
  "help.features.sync": "🔄 Αυτόματος συγχρονισμός μηνυμάτων κάθε 5 δευτερόλεπτα",
  "help.features.deleteSync": "🗑️ Αυτόματος συγχρονισμός διαγραμμένων μηνυμάτων μεταξύ συσκευών",
  "help.features.notifications": "🔔 Ηχητικές ειδοποιήσεις για νέα μηνύματα που λαμβάνονται",
  "help.features.retranslation": "🔄 Αυτόματη εκ νέου μετάφραση των μηνυμάτων εάν αποτύχει την πρώτη φορά",
  "help.features.preview": "👁️ Προεπισκόπηση αρχείων πριν από την αποστολή",
  "help.features.security": "🔒 Σύστημα ασφαλείας με CAPTCHA, δακτυλικό αποτύπωμα, περιορισμό ρυθμού και υποχρεωτική ροή T&C",
  "help.features.passwordRecovery": "🔑 Ανάκτηση κωδικού πρόσβασης μέσω email",
  "help.features.emailConfirmation": "📧 Επιβεβαίωση λογαριασμού μέσω email με σύνδεσμο ενεργοποίησης",
  "help.features.invitations": "📧 Ιδιωτικές προσκλήσεις μέσω email - Προσκαλέστε εξωτερικές επαφές με καθορισμένη γλώσσα και πλαίσιο",
  "help.features.invitationsManagement": "📋 Ολοκλήρωση διαχείρισης προσκλήσεων - Λίστα, αποστολή ή ακύρωση εκκρεμών προσκλήσεων από το μενού",
  "help.features.contactStatus": "🏷️ Ορατές καταστάσεις επαφών - Δείτε την κατάσταση κάθε επαφής (σε εκκρεμότητα, εγγεγραμμένη, έτοιμη για συνομιλία)",
  "help.features.favorites": "⭐ Σύστημα αγαπημένων - Επισημάνετε τις επαφές ως αγαπημένες για γρήγορη πρόσβαση σε αυτές",
  "help.features.profilePhoto": "📸 Βελτιωμένη Μεταφόρτωση Φωτογραφίας Προφίλ – Επιλέξτε εικόνες από τη συλλογή με άμεση προεπισκόπηση",
  "help.features.translationSender": "👁️ Προβολή μεταφράσεων για τον αποστολέα - Δείτε πώς μεταφράστηκε το μήνυμά σας στη γλώσσα του παραλήπτη",
  "help.features.unifiedContacts": "🔗 Ενοποιημένο μοντέλο επαφής - Οι επαφές προέρχονται από υπάρχουσες προσκλήσεις και συνομιλίες",
  "help.features.privacy": "🔒 Ιδιωτική λειτουργία από προεπιλογή - Το προφίλ σας είναι ιδιωτικό και είναι προσβάσιμο μόνο με απευθείας πρόσκληση",
  "help.features.export": "💾 Εξαγωγή συνομιλίας - Εξαγωγή ολόκληρων συνομιλιών σε PDF ή HTML με εικόνες και αρχεία",
  "help.tips.title": "Χρήσιμες συμβουλές",
  "help.tips.language": "✅ Ρυθμίστε τη γλώσσα σας με τον επιλογέα σημαίας {count}. Οι όροι και τα μηνύματα ηλεκτρονικού ταχυδρομείου εμφανίζονται σε αυτήν τη γλώσσα",
  "help.tips.status": "✅ Ενημερώστε την κατάσταση παρουσίας σας, ώστε οι άλλοι να γνωρίζουν τη διαθεσιμότητά σας",
  "help.tips.statusCustom": "✅ Δημιουργήστε προσαρμοσμένες καταστάσεις με emoji και μήνυμα για να εκφράσετε την τρέχουσα κατάστασή σας",
  "help.tips.search": "✅ Επισημάνετε τα αγαπημένα (αστέρι) και αποκλείστε τους χρήστες από το modal \"Χρήστες\".",
  "help.tips.contactsFilter": "✅ Χρησιμοποιήστε το κουμπί ματιών (👁️) στην επάνω γραμμή για να εμφανίσετε ή να αποκρύψετε τις μη αγαπημένες επαφές",
  "help.tips.contactAlias": "✅ Κάντε κλικ στο όνομα της επαφής στη συνομιλία για να προσθέσετε ένα προσαρμοσμένο ψευδώνυμο και ιδιωτικές σημειώσεις",
  "help.tips.avatar": "✅ Κάντε κλικ στο avatar μιας επαφής για να δείτε την εικόνα της σε μεγαλύτερη",
  "help.tips.messages": "✅ Το εικονίδιο ArChat® αναβοσβήνει όταν έχετε μη αναγνωσμένα μηνύματα. εισαγάγετε emojis με το πρόγραμμα εκκίνησης OpenMoji",
  "help.tips.attachments": "✅ Επισυνάψτε εικόνες, βίντεο ή PDF χρησιμοποιώντας το κουμπί κλιπ (📎). συμβατή με γραπτή επικοινωνία",
  "help.tips.camera": "✅ Χρησιμοποιήστε την κάμερα για να τραβήξετε φωτογραφίες απευθείας από την εφαρμογή",
  "help.tips.compression": "✅ Οι εικόνες συμπιέζονται αυτόματα για εξοικονόμηση χώρου",
  "help.tips.delete": "✅ Μπορείτε να διαγράψετε τα δικά σας μηνύματα κάνοντας κλικ στο κουμπί διαγραφής",
  "help.tips.profile": "✅ Επεξεργαστείτε το προφίλ σας χωρίς αναψυκτικό και κάντε εναλλαγή μεταξύ Αργεντινής / Σκούρο (ανοιχτό ή σκούρο θέμα).",
  "help.tips.themes": "✅ Αλλάξτε το θέμα από τις Ρυθμίσεις > Εμφάνιση: Αργεντινή (ανοιχτό μπλε) ή Σκούρο (βαθύ μωβ)",
  "help.tips.country": "✅ Επιλέξτε τη χώρα σας στο προφίλ, ώστε η ζώνη ώρας να ρυθμίζεται αυτόματα",
  "help.message_time_context.title": "Χρονικό πλαίσιο μηνυμάτων",
  "help.message_time_context.description": "Κάθε μήνυμα μπορεί να αποθηκεύσει την τοπική ώρα, τη ζώνη ώρας και τη χώρα του αποστολέα τη στιγμή της αποστολής. Με αυτόν τον τρόπο μπορείτε να δείτε πού και πότε έστειλε ο άλλος χρήστης.",
  "help.message_time_context.point1": "Στο ΔΩΡΕΑΝ πρόγραμμα εμφανίζεται μόνο η ώρα στη ζώνη ώρας σας (δέκτης).",
  "help.message_time_context.point2": "Στο σχέδιο PRO, εμφανίζονται επίσης η τοπική ώρα, η χώρα και η ζώνη ώρας του εκδότη.",
  "help.message_time_context.point3": "Το πλαίσιο αποθηκεύεται ιστορικά σε κάθε μήνυμα.",
  "help.message_time_context.point4": "Προηγμένες δυνατότητες ελέγχου είναι διαθέσιμες σε υψηλότερα σχέδια.",
  "help.tips.registration": "✅ Πριν εγγραφείτε, αποδεχτείτε τους Όρους και Προϋποθέσεις στη γλώσσα σας. στη συνέχεια επαληθεύστε το email σας για να ενεργοποιήσετε τον λογαριασμό",
  "help.tips.writing": "✅ Γράψτε ξεκάθαρα μηνύματα: Το ArChat® μεταφράζει το νόημα του γραπτού κειμένου, διατηρώντας το πλαίσιο και τη σαφήνεια",
  "help.tips.install": "✅ Εγκαταστήστε το ArChat® ως εφαρμογή PWA στη συσκευή σας για γρήγορη πρόσβαση στην επιφάνεια εργασίας",
  "help.tips.sync": "✅ Τα μηνύματα συγχρονίζονται αυτόματα κάθε 5 δευτερόλεπτα - δεν χρειάζεται ανανέωση",
  "help.tips.deleteSync": "✅ Εάν διαγράψετε ένα μήνυμα, θα διαγραφεί αυτόματα σε όλες τις συσκευές του παραλήπτη",
  "help.tips.notifications": "✅ Θα ακούσετε έναν ήχο όταν λάβετε ένα νέο μήνυμα από άλλο χρήστη",
  "help.tips.retranslation": "✅ Εάν ένα μήνυμα δεν μεταφράστηκε σωστά, το σύστημα θα προσπαθήσει να το μεταφράσει ξανά αυτόματα",
  "help.tips.preview": "✅ Ελέγξτε την προεπισκόπηση του αρχείου πριν στείλετε για να βεβαιωθείτε ότι είναι το σωστό",
  "help.tips.passwordRecovery": "✅ Εάν ξεχάσατε τον κωδικό πρόσβασής σας, χρησιμοποιήστε τον σύνδεσμο \"Ξεχάσατε τον κωδικό πρόσβασής σας;\" στην είσοδο",
  "help.tips.emailConfirmation": "✅ Ελέγξτε το email σας μετά την εγγραφή και κάντε κλικ στον σύνδεσμο επιβεβαίωσης",
  "help.tips.languageChange": "✅ Αλλάξτε τη γλώσσα σας από τον επιλογέα σημαίας: T&C, email και UI ενημερώνονται άμεσα",
  "help.tips.inputFixed": "✅ Σε υπολογιστή, η γραμμή γραφής είναι στερεωμένη στο κάτω μέρος της οθόνης για μεγαλύτερη άνεση",
  "help.tips.invitations": "✅ Προσκαλέστε επαφές μέσω email από το προφίλ σας - Καθορίστε τη γλώσσα και τη λειτουργία συνομιλίας από την αρχή",
  "help.tips.invitationsManagement": "✅ Διαχειριστείτε τις προσκλήσεις σας από το μενού \"Απεσταλμένες προσκλήσεις\" - Αποστολή εκ νέου email ή ακύρωση προσκλήσεων σε εκκρεμότητα",
  "help.tips.contactStatus": "✅ Δείτε την κατάσταση κάθε επαφής στη λίστα - Σε εκκρεμότητα (πορτοκαλί), Εγγεγραμμένη (πράσινη) ή Ενεργή συνομιλία (μπλε)",
  "help.tips.favorites": "✅ Επισημάνετε τις επαφές ως αγαπημένες με το αστέρι ⭐ - Τα αγαπημένα εμφανίζονται πρώτα στη λίστα σας",
  "help.tips.profilePhoto": "✅ Ανεβάστε τη φωτογραφία του προφίλ σας από το \"Choose from gallery\" - Θα δείτε μια προεπισκόπηση πριν την αποθήκευση",
  "help.tips.translationSender": "✅ Όταν στέλνετε ένα μήνυμα, επεκτείνετε τον πίνακα μετάφρασης για να δείτε πώς μεταφράστηκε στη γλώσσα του παραλήπτη",
  "help.tips.unifiedContacts": "✅ Οι επαφές σας εμφανίζονται αυτόματα όταν δέχονται προσκλήσεις ή έχουν συνομιλίες μαζί τους",
  "help.tips.privacy": "✅ Το προφίλ σας είναι ιδιωτικό από προεπιλογή - Ενεργοποιήστε τη δημόσια ορατότητα στο Προφίλ > Απόρρητο εάν θέλετε να σας βρουν άλλοι",
  "help.tips.export": "✅ Εξαγωγή ολόκληρων συνομιλιών χρησιμοποιώντας το κουμπί ⬇️ στην κεφαλίδα - Επιλέξτε PDF ή HTML με όλες τις εικόνες",
  "help.support.title": "Μέσον",
  "help.support.description": "Εάν έχετε προβλήματα ή ερωτήσεις, επικοινωνήστε με τον διαχειριστή του συστήματός σας ή διαβάστε τη διαθέσιμη τεχνική τεκμηρίωση.",
  "help.about.title": "Για",
  "help.about.developer": "Αναπτύχθηκε από:",
  "help.about.location": "MDQ - ΑΡΓΕΝΤΙΝΗ",
  "help.about.linkedin": "Προβολή προφίλ στο LinkedIn",
  "presence.custom.suggestion.coffee": "Έχοντας μερικούς συντρόφους ☕",
  "presence.custom.suggestion.soccer": "Στο γήπεδο ⚽",
  "presence.custom.suggestion.working": "Δουλεύοντας σαν τρελός 💪",
  "presence.custom.suggestion.lunch": "Μεσημεριανό γεύμα 🍽️",
  "presence.custom.suggestion.family": "Οικογενειακό γεύμα 👨‍👩‍👧‍👦",
  "presence.custom.suggestion.studying": "Μελέτη 📚",
  "presence.custom.suggestion.travel": "Σε ταξίδι ✈️",
  "presence.custom.suggestion.meeting": "Σε συνάντηση 💼",
  "presence.custom.suggestion.resting": "Ξεκούραση 😴",
  "presence.custom.suggestion.gaming": "Παίζοντας βιντεοπαιχνίδια 🎮",
  "presence.custom.suggestion.reading": "Διαβάζοντας 📖",
  "presence.custom.suggestion.offlineSoon": "Θα επιστρέψω αμέσως ⏳",
  "export.title": "Εξαγωγή συνομιλίας",
  "export.description": "Επιλέξτε τη μορφή με την οποία θέλετε να εξαγάγετε αυτήν τη συνομιλία:",
  "export.progress": "Εξαγωγή...",
  "export.format.pdf": "PDF",
  "export.format.pdf.description": "Έγγραφο PDF με όλες τις εικόνες και τα αρχεία",
  "export.format.html": "Html",
  "export.format.html.description": "Αρχείο HTML που μπορείτε να ανοίξετε σε οποιοδήποτε πρόγραμμα περιήγησης",
  "export.info": "Η εξαγωγή θα περιλαμβάνει όλα τα μηνύματα, τις εικόνες και τα αρχεία από αυτήν τη συνομιλία.",
  "export.pro_required.title": "Εξαγωγή συνομιλίας",
  "export.pro_required.message": "Αυτή η δυνατότητα είναι διαθέσιμη στο πρόγραμμα PRO.",
  'invitation.top.title': 'Κορυφαίοι δημιουργοί δικτύου',
  'invitation.top.invitesSuffix': 'προσκλήσεις',
  "invitation.safe.phase_notice": "Ενεργή ασφαλής φάση: οφέλη σε εκκρεμότητα εμπορικής ενεργοποίησης (χωρίς πραγματικό αντίκτυπο στα όρια).",
  "invitation.safe.generate_code": "Δημιουργία συνδέσμου/κώδικα",
  "invitation.safe.refresh_top3": "Ενημέρωση Top 3",
  "invitation.safe.top_loading": "Φόρτωση κορυφαίων προσκεκλημένων...",
  "invitation.safe.top_empty": "Δεν υπάρχουν ακόμη επιλεγμένοι προσκεκλημένοι.",
  "invitation.safe.hide_full_ranking": "Απόκρυψη πλήρους κατάταξης",
  "invitation.safe.view_full_ranking": "Δείτε την πλήρη κατάταξη",
  "invitation.safe.hide_metrics_dashboard": "Απόκρυψη πίνακα ελέγχου μετρήσεων",
  "invitation.safe.view_metrics_dashboard": "Προβολή πίνακα ελέγχου μετρήσεων",
  "invitation.safe.prepared_link": "Ο σύνδεσμος ετοιμάστηκε",
  "invitation.safe.email_placeholder": "email@dominio.com",
  "invitation.safe.register_pending": "Εγγραφή σε εκκρεμή πρόσκληση",
  "invitation.safe.status_summary": "Περίληψη κατάστασης",
  "invitation.safe.summary.pending": "Σκουλαρίκια",
  "invitation.safe.summary.registered": "Εγγεγραμμένος",
  "invitation.safe.summary.active": "Ενεργός",
  "invitation.safe.summary.validated": "Επικυρώθηκε",
  "invitation.safe.summary.rejected": "Απορρίφθηκε",
  "invitation.safe.sent_invitations": "Εκδόθηκαν προσκλήσεις",
  "invitation.safe.table.id": "ταυτότητα",
  "invitation.safe.table.invited_email": "Email επισκέπτη",
  "invitation.safe.table.code": "Κώδικας",
  "invitation.safe.table.status": "Κατάσταση",
  "invitation.safe.table.created": "Δημιουργήθηκε",
  "invitation.safe.empty_sent": "Δεν έχουν εκδοθεί ακόμη προσκλήσεις.",
  "invitation.safe.simulated_rewards": "Αποκτήθηκαν προσομοιωμένες ανταμοιβές",
  "invitation.safe.empty_rewards": "Δεν υπάρχουν προσομοιωμένες ανταμοιβές προς το παρόν.",
  "invitation.safe.error.load_status": "Δεν ήταν δυνατή η φόρτωση της κατάστασης πρόσκλησης.",
  "invitation.safe.error.generate_code": "Δεν ήταν δυνατή η δημιουργία του κώδικα.",
  "invitation.safe.error.invalid_email": "Εισαγάγετε ένα έγκυρο email για εγγραφή πρόσκλησης.",
  "invitation.safe.error.register_pending": "Δεν ήταν δυνατή η εγγραφή της εκκρεμούς πρόσκλησης.",
  "invitation.safe.success.code_generated": "Ο κώδικας δημιουργήθηκε με επιτυχία.",
  "invitation.safe.success.pending_registered": "Η πρόσκληση σε εκκρεμότητα καταχωρήθηκε σε ασφαλή λειτουργία.",
  "invitation.ranking.position": "Θέση",
  "invitation.ranking.user": "Μεταχειριζόμενος",
  "invitation.ranking.validatedInvites": "Επικυρωμένες προσκλήσεις",
  "invitation.ranking.empty": "Δεν υπάρχουν επικυρωμένες προσκλήσεις για εμφάνιση.",
  "invitation.ranking.loading": "Φόρτωση κατάταξης...",
  "invitation.ranking.loadError": "Δεν ήταν δυνατή η φόρτωση της κατάταξης.",
  "invitation.copy.link": "Αντιγραφή συνδέσμου",
  "invitation.copy.success": "Ο σύνδεσμος αντιγράφηκε στο πρόχειρο",
  "invitation.accept.title": "Αποδεχτείτε την πρόσκληση",
  "invitation.accept.description": "Έχετε προσκληθεί να συνομιλήσετε στο ArChat®",
  "invitation.accept.inviter": "Προσκεκλημένος από",
  "invitation.accept.message": "προσωπικό μήνυμα",
  "invitation.accept.login": "Σύνδεση",
  "invitation.accept.register": "Μητρώο",
  "invitation.accept.error.invalid": "Μη έγκυρο διακριτικό πρόσκλησης",
  "invitation.accept.error.expired": "Αυτή η πρόσκληση έχει λήξει",
  "invitation.accept.error.accepted": "Αυτή η πρόσκληση έχει ήδη γίνει αποδεκτή",
  "invitation.accept.error.cancelled": "Αυτή η πρόσκληση ακυρώθηκε",
  "invitation.accept.error.email_mismatch": "Το email του λογαριασμού σας δεν ταιριάζει με το email πρόσκλησης",
  "invitation.accept.success": "Η πρόσκληση αποδεκτή. Ανακατεύθυνση στη συνομιλία...",
  "invitations.sent.empty": "Δεν υπάρχουν εκκρεμείς προσκλήσεις",
  "invitations.columns.email": "E-mail",
  "invitations.columns.language": "Γλώσσα",
  "invitations.columns.status": "Κατάσταση",
  "invitations.columns.sentAt": "Στάλθηκε",
  "invitations.columns.actions": "Δράσεις",
  "invitations.status.pending": "Σκουλαρίκι",
  "invitations.status.accepted": "Δεκτός",
  "invitations.status.cancelled": "Ακυρώθηκε",
  "invitations.status.expired": "Λήξη",
  "invitations.actions.copy": "Αντιγραφή συνδέσμου",
  "invitations.waitBeforeResend": "Δεν μπορείτε να στείλετε ξανά την πρόσκληση ακόμα. Πρέπει να περιμένετε 10 λεπτά μεταξύ κάθε αποστολής για να αποφύγετε την ανεπιθύμητη αλληλογραφία του επισκέπτη χρήστη.",
  "invitations.captchaQuestion": "Πόσο είναι το %1 + %2;",
  "invitations.resendSuccess": "Η πρόσκληση προωθήθηκε με επιτυχία.",
  "invitations.dailyLimit": "Έχετε συμπληρώσει τις μέγιστες επιτρεπόμενες εκ νέου υποβολές σήμερα.",
  "invitations.invalidEmail": "Ο διακομιστής αλληλογραφίας ανέφερε ότι αυτή η διεύθυνση δεν είναι έγκυρη.",
  "profile.privacy.title": "Μυστικότητα",
  "profile.privacy.public_visibility": "Κάντε το προφίλ μου δημόσια ορατό",
  "profile.privacy.public_warning": "Αυτό επιτρέπει σε κάθε χρήστη του ArChat® να σας βρει και να ξεκινήσει μια συνομιλία.",
  "profile.privacy.private_info": "Το προφίλ σας είναι ιδιωτικό. Μόνο οι χρήστες που προσκαλείτε ή που σας προσκαλούν θα μπορούν να συνομιλούν μαζί σας.",
  "profile.privacy.private_default": "Από προεπιλογή, το προφίλ σας είναι ιδιωτικό για μεγαλύτερη ασφάλεια.",
  "common.save": "Διατήρηση",
  "common.saving": "Οικονομία...",
  'buttons.accept': 'Αποδοχή',
  "buttons.cancel": "Ματαίωση",
  "buttons.save": "Διατήρηση",
  "buttons.edit": "Εκδίδω",
  "buttons.retry": "Δοκιμάζω πάλι",
  "buttons.confirm": "Επιβεβαιώνω",
  "buttons.yes": "Ναι",
  "buttons.no": "Οχι",
  "buttons.send": "Στέλνω",
  "buttons.close": "Κοντά",
  "buttons.continue": "Συνεχίζω",
  "buttons.delete": "Εξαλείφω",
  "buttons.logout": "Πάω έξω",
  "buttons.back": "Απόδοση",
  "buttons.update": "Εκσυγχρονίζω",
  "buttons.upload": "Αύξηση",
  "buttons.select": "Επιλέγω",
  "achievement.unlocked": "Το επίτευγμα ξεκλειδώθηκε",
  "achievement.continue": "Συνεχίζω",
  "contact.edit.info.personalized": "Αυτές οι αλλαγές είναι εξατομικευμένες μόνο για εσάς και δεν επηρεάζουν άλλους χρήστες.",
  "contact.edit.profileInfo": "Πληροφορίες προφίλ",
  "dashboard.loading": "Φόρτωση δεδομένων...",
  "dashboard.error.title": "Λάθος",
  "dashboard.error.load": "Δεν ήταν δυνατή η φόρτωση των δεδομένων χρήσης",
  "dashboard.error.generic": "Σφάλμα κατά τη φόρτωση του πίνακα ελέγχου",
  "dashboard.error.no_data": "Δεν ήταν δυνατή η φόρτωση των δεδομένων",
  "dashboard.retry": "Δοκιμάζω πάλι",
  "dashboard.unlimited": "Απεριόριστος",
  'dashboard.not_available': 'Μη διαθέσιμο',
  "dashboard.plan.free": "FREE",
  "dashboard.plan.pro": "PRO",
  "dashboard.plan.enterprise": "ENTERPRISE",
  "dashboard.card.chars": "Χαρακτήρες",
  "dashboard.card.chars_month": "Χαρακτήρες αυτόν τον μήνα",
  "dashboard.card.storage": "Αποθήκευση",
  "dashboard.card.devices": "Ενεργές συσκευές",
  "dashboard.admin.title": "Μετρήσεις ανάπτυξης",
  "dashboard.admin.newUsersToday": "Νέοι χρήστες σήμερα",
  "dashboard.admin.messagesSentToday": "Τα μηνύματα στάλθηκαν σήμερα",
  "dashboard.admin.translationsUsed": "Μεταφράσεις που χρησιμοποιήθηκαν",
  "dashboard.admin.invitesCreated": "Δημιουργήθηκαν προσκλήσεις",
  "dashboard.admin.invitesValidated": "Επικυρωμένες προσκλήσεις",
  "dashboard.admin.inviteConversion": "Μετατροπή πρόσκλησης",
  "dashboard.admin.kFactor": "K-Factor",
  "dashboard.admin.newUsers": "Νέοι χρήστες",
  "dashboard.admin.messagesSent": "Απεσταλμένα μηνύματα",
  "dashboard.admin.noData": "Δεν υπάρχουν δεδομένα",
  "dashboard.admin.kFactor.viral": "Ιογενείς",
  "dashboard.admin.kFactor.stable": "Σταθερός",
  "dashboard.admin.kFactor.low": "Χαμηλός",
  "dashboard.admin.emailMetrics": "Μετρήσεις ηλεκτρονικού ταχυδρομείου",
  "dashboard.admin.email.sent": "Στάλθηκε",
  "dashboard.admin.email.delivered": "Παραδόθηκε",
  "dashboard.admin.email.opened": "ανοιχτό",
  "dashboard.admin.email.clicked": "Κλικ",
  "dashboard.admin.email.bounced": "Αναπήδησε",
  "dashboard.admin.email.deliveryRate": "Ποσοστό παράδοσης",
  "dashboard.admin.email.openRate": "Ανοιχτό ποσοστό",
  "dashboard.admin.email.bounceRate": "ποσοστό εγκατάλειψης",
  "dashboard.admin.funnelMetrics": "Μετρήσεις διοχέτευσης",
  "dashboard.admin.funnel.registered": "Εγγεγραμμένος",
  "dashboard.admin.funnel.confirmed": "Επιβεβαιωμένος",
  "dashboard.admin.funnel.loggedIn": "Πρώτη σύνδεση",
  "dashboard.admin.funnel.firstMessage": "Πρώτο μήνυμα",
  "dashboard.admin.funnel.abandoned": "Εγκαταλειμμένος",
  "dashboard.admin.funnel.conversionRate": "Ποσοστό μετατροπής",
  "dashboard.admin.funnel.activationRate": "Ρυθμός ενεργοποίησης",
  "dashboard.admin.funnel.dropoffRate": "Ποσοστό εγκατάλειψης",
  "dashboard.admin.loading": "Φόρτωση μετρήσεων...",
  "dashboard.admin.errorLoad": "Δεν ήταν δυνατή η φόρτωση του πίνακα ελέγχου μετρήσεων.",
  "dashboard.admin.growthViral": "Ανάπτυξη ιών",
  "dashboard.admin.growthStable": "Σταθερή ανάπτυξη",
  "dashboard.admin.growthLow": "Χαμηλή ανάπτυξη",
  "dashboard.upgrade.title": "Χρειάζεστε περισσότερους πόρους;",
  'dashboard.upgrade.message': 'Upgrade your plan to get more contacts, characters, storage and active devices.',
  "dashboard.upgrade.button": "Βελτίωση σχεδίου",
  "upgrade.title": "Βελτίωση σχεδίου",
  "upgrade.close": "Κοντά",
  "upgrade.cancel": "Ματαίωση",
  "upgrade.activate": "Ενεργοποιήστε το πρόγραμμα PRO",
  "upgrade.activating": "Ενεργοποιητικός...",
  'upgrade.price.amount': '',
  'upgrade.price.period': '',
  'upgrade.price.note': '',
  "upgrade.comparison.title": "Σύγκριση σχεδίων",
  "upgrade.free.label": "Δωρεάν σχέδιο",
  "upgrade.free.limits.contacts": "2 επαφές το πολύ",
  "upgrade.free.limits.conversations": "2 συνομιλίες το πολύ",
  "upgrade.free.limits.no_export": "Καμία εξαγωγή δεδομένων",
  "upgrade.free.limits.no_advanced": "Χωρίς προηγμένες λειτουργίες",
  "upgrade.pro.label": "Pro Plan",
  "upgrade.pro.recommended": "ΣΥΝΙΣΤΕΙΤΑΙ",
  'upgrade.pro.benefits.contacts': 'Unlimited contacts',
  'upgrade.pro.benefits.contacts.desc': 'Add all the contacts you need without restrictions',
  'upgrade.pro.benefits.conversations': 'Unlimited conversations',
  'upgrade.pro.benefits.conversations.desc': 'Keep all active conversations you need',
  "upgrade.pro.benefits.export": "Εξαγωγή συνομιλίας",
  "upgrade.pro.benefits.export.desc": "Εξαγωγή των συνομιλιών σας σε πολλές μορφές (PDF, TXT, JSON)",
  "upgrade.pro.benefits.notifications": "Προηγμένες ειδοποιήσεις",
  "upgrade.pro.benefits.notifications.desc": "Προσαρμοσμένες ειδοποιήσεις και σύνθετες ρυθμίσεις",
  'upgrade.pro.benefits.translation': 'Unlimited automatic translation',
  'upgrade.pro.benefits.translation.desc': 'Translate messages without usage limits',
  'upgrade.pro.benefits.files': 'Unlimited file sharing',
  'upgrade.pro.benefits.files.desc': 'Share files of any size without restrictions',
  "upgrade.pro.benefits.themes": "Προσαρμοσμένα θέματα",
  "upgrade.pro.benefits.themes.desc": "Πρόσβαση σε όλα τα θέματα και προηγμένη προσαρμογή",
  "upgrade.pro.benefits.security": "Προηγμένη ασφάλεια",
  "upgrade.pro.benefits.security.desc": "Πρόσθετη προστασία και βελτιωμένα χαρακτηριστικά απορρήτου",
  "upgrade.pro.benefits.analytics": "Στατιστική και ανάλυση",
  "upgrade.pro.benefits.analytics.desc": "Πρόσβαση σε λεπτομερή στατιστικά στοιχεία της δραστηριότητάς σας",
  "upgrade.pro.benefits.priority": "Υποστήριξη κατά προτεραιότητα",
  "upgrade.pro.benefits.priority.desc": "Προτεραιότητα προσοχής και γρήγορη απάντηση στα ερωτήματά σας",
  "upgrade.enterprise.label": "Επιχειρηματικό Σχέδιο",
  "upgrade.enterprise.title": "ENTERPRISE",
  "upgrade.enterprise.benefits.contacts": "Απεριόριστες επαφές",
  "upgrade.enterprise.benefits.support": "Υποστήριξη κατά προτεραιότητα 24/7",
  "upgrade.enterprise.benefits.custom": "Προσαρμοσμένες λύσεις",
  "upgrade.enterprise.benefits.advanced": "Προηγμένες επιχειρηματικές δυνατότητες",
  "upgrade.enterprise.benefits.integration": "Προσαρμοσμένες ενσωματώσεις",
  "upgrade.enterprise.benefits.dedicated": "Αποκλειστική υποστήριξη",
  "upgrade.success.title": "Ενεργοποιήθηκε το σχέδιο PRO",
  "upgrade.success.message": "Το σχέδιό σας έχει αναβαθμιστεί σε PRO. Απολαύστε όλες τις απεριόριστες δυνατότητες.",
  "upgrade.error.title": "Σφάλμα κατά την ενεργοποίηση PRO",
  "upgrade.error.message": "Δεν ήταν δυνατή η ενημέρωση του σχεδίου. Δοκιμάστε ξανά.",
  "upgrade.error.generic": "Παρουσιάστηκε απροσδόκητο σφάλμα. Δοκιμάστε ξανά.",
  'upgrade.benefits.contacts': 'Unlimited contacts',
  'upgrade.benefits.contacts.desc': 'Add all the contacts you need without restrictions',
  'upgrade.benefits.conversations': 'Unlimited conversations',
  'upgrade.benefits.conversations.desc': 'Keep all active conversations you need',
  "upgrade.benefits.export": "Εξαγωγή συνομιλίας",
  "upgrade.benefits.export.desc": "Εξαγωγή των συνομιλιών σας σε πολλές μορφές (PDF, TXT, JSON)",
  "upgrade.benefits.notifications": "Προηγμένες ειδοποιήσεις",
  "upgrade.benefits.notifications.desc": "Προσαρμοσμένες ειδοποιήσεις και σύνθετες ρυθμίσεις",
  'upgrade.benefits.translation': 'Unlimited automatic translation',
  'upgrade.benefits.translation.desc': 'Translate messages without usage limits',
  'upgrade.benefits.files': 'Unlimited file sharing',
  'upgrade.benefits.files.desc': 'Share files of any size without restrictions',
  "upgrade.benefits.themes": "Προσαρμοσμένα θέματα",
  "upgrade.benefits.themes.desc": "Πρόσβαση σε όλα τα θέματα και προηγμένη προσαρμογή",
  "upgrade.benefits.security": "Προηγμένη ασφάλεια",
  "upgrade.benefits.security.desc": "Πρόσθετη προστασία και βελτιωμένα χαρακτηριστικά απορρήτου",
  "upgrade.benefits.analytics": "Στατιστική και ανάλυση",
  "upgrade.benefits.analytics.desc": "Πρόσβαση σε λεπτομερή στατιστικά στοιχεία της δραστηριότητάς σας",
  "upgrade.benefits.priority": "Υποστήριξη κατά προτεραιότητα",
  "upgrade.benefits.priority.desc": "Προτεραιότητα προσοχής και γρήγορη απάντηση στα ερωτήματά σας",
  "upgrade.limits.contacts": "2 επαφές το πολύ",
  "upgrade.limits.conversations": "2 συνομιλίες το πολύ",
  "upgrade.limits.no_export": "Καμία εξαγωγή δεδομένων",
  "upgrade.limits.no_advanced": "Χωρίς προηγμένες λειτουργίες",
  "api.error.image_processing_not_available": "Η επεξεργασία εικόνας δεν είναι διαθέσιμη στον διακομιστή",
  "api.error.image_functions_not_available": "Οι λειτουργίες επεξεργασίας εικόνας δεν είναι διαθέσιμες",
  "api.error.method_not_allowed": "Μη επιτρεπόμενη μέθοδος",
  "api.error.user_not_identified": "Άγνωστος χρήστης",
  "api.error.upload_file_too_large_php": "Το αρχείο υπερβαίνει το μέγιστο επιτρεπόμενο μέγεθος από την PHP",
  "api.error.upload_file_too_large_form": "Το αρχείο υπερβαίνει το μέγιστο επιτρεπόμενο μέγεθος από τη φόρμα",
  "api.error.upload_file_partial": "Το αρχείο ανέβηκε μερικώς",
  "api.error.upload_no_file": "Δεν μεταφορτώθηκε αρχείο",
  "api.error.upload_no_temp_dir": "Λείπει ο προσωρινός κατάλογος",
  "api.error.upload_cant_write": "Σφάλμα κατά την εγγραφή του αρχείου στο δίσκο",
  "api.error.upload_extension_stopped": "Μια επέκταση PHP σταμάτησε τη μεταφόρτωση",
  "api.error.upload_generic": "Σφάλμα μεταφόρτωσης αρχείου",
  "api.error.file_type_not_allowed": "Δεν επιτρέπεται ο τύπος αρχείου. Επιτρέπονται μόνο εικόνες (JPEG, PNG, GIF, WEBP).",
  "api.error.file_too_large": "Το αρχείο είναι πολύ μεγάλο (μέγιστο 10 MB)",
  "api.error.storage_limit_exceeded": "Υπέρβαση του ορίου αποθήκευσης. Αναβαθμίστε το σχέδιό σας για να ανεβάσετε περισσότερα αρχεία.",
  "api.error.user_not_found": "Ο χρήστης δεν βρέθηκε ή ανενεργός",
  "api.error.image_directory_access": "Σφάλμα πρόσβασης στον κατάλογο εικόνων",
  "api.error.file_extension_not_allowed": "Δεν επιτρέπεται η επέκταση αρχείου",
  "api.error.temp_file_save": "Σφάλμα κατά την αποθήκευση του προσωρινού αρχείου",
  "api.error.image_processing": "Σφάλμα επεξεργασίας εικόνας",
  "api.error.database_update": "Σφάλμα κατά την ενημέρωση της βάσης δεδομένων",
  "api.error.internal_server_error": "Εσωτερικό σφάλμα διακομιστή",
  "api.error.internal_server_error_debug": "Εσωτερικό σφάλμα διακομιστή",
  "api.error.user_id_required": "Απαιτούμενο αναγνωριστικό χρήστη",
  "api.error.profile_not_found": "Το προφίλ δεν βρέθηκε",
  "api.error.profile_load_failed": "Σφάλμα κατά τη φόρτωση του προφίλ",
  "api.error.invalid_data": "Μη έγκυρα δεδομένα",
  "api.error.validation_errors": "Σφάλματα επικύρωσης",
  "api.error.profile_update_failed": "Δεν ήταν δυνατή η ενημέρωση του προφίλ",
  "api.error.profile_update_error": "Σφάλμα ενημέρωσης προφίλ",
  "api.success.photo_updated": "Ενημερωμένη φωτογραφία",
  "api.success.profile_loaded": "Το προφίλ φορτώθηκε με επιτυχία",
  "api.success.profile_updated": "Το προφίλ ενημερώθηκε με επιτυχία",
  "errors.deviceLimit.title": "Συμπληρώθηκε το όριο συσκευής",
  "errors.deviceLimit.solution": "Για να συνεχίσετε, αποσυνδεθείτε από άλλες συσκευές ή αναβαθμίστε το σχέδιό σας.",
  "errors.network.title": "Σφάλμα σύνδεσης",
  "errors.network.message": "Δεν ήταν δυνατή η σύνδεση στον διακομιστή. Ελέγξτε τη σύνδεσή σας στο διαδίκτυο.",
  "errors.server.invalidResponse.title": "Σφάλμα διακομιστή",
  "errors.server.invalidResponse.message": "Ο διακομιστής επέστρεψε μια μη έγκυρη απάντηση. Προσπαθήστε ξανά.",
  "errors.modal.title": "Λάθος",
  "errors.modal.copyDetails": "Αντιγραφή λεπτομερειών",
  "errors.modal.close": "Κοντά",
  "errors.modal.reportSupport": "Αναφορά στην υποστήριξη",
  "errors.modal.code": "Κώδικας",
  "errors.modal.message": "Μήνυμα",
  "errors.modal.path": "Διαδρομή",
  "errors.modal.time": "Ωρα",
  "errors.modal.timestamp": "Χρονική σήμανση",
  "errors.modal.copied": "Αντιγραμμένη λεπτομέρεια",
  "errors.generic.title": "Λάθος",
  "errors.generic.message": "Παρουσιάστηκε σφάλμα. Προσπαθήστε ξανά.",
  "errors.unexpected": "Παρουσιάστηκε απροσδόκητο σφάλμα. Προσπαθήστε ξανά.",
  "errors.boundary.title": "ΣΦΑΛΜΑ ΑΝΤΙΔΡΑΣΗΣ ΣΥΓΓΡΑΦΗΚΕ",
  "errors.boundary.request_id": "X-Request-ID:",
  "errors.boundary.correlate": "Χάρτης στο backend/logs/structured.log",
  "errors.boundary.message_label": "Μήνυμα:",
  "errors.boundary.stack_trace": "Ίχνη στοίβας",
  "errors.boundary.component_stack": "στοίβα συστατικών",
  "errors.boundary.empty": "(αδειάζω)",
  "errors.boundary.reload_page": "Επαναφόρτωση σελίδας",
  "errors.ui_boundary.refresh": "Σφάλμα διεπαφής ArChat — επαναφόρτωση σελίδας",
  "bootstrap.error.title": "ArChat® — Σφάλμα εκκίνησης",
  "common.reload": "Επαναφόρτιση",
  "errors.avatarTooLarge": "Η εικόνα υπερβαίνει το επιτρεπόμενο μέγεθος των 2 MB.",
  "errors.avatarTooLarge.title": "Η εικόνα είναι πολύ μεγάλη",
  "errors.avatarTooLarge.message": "Η εικόνα υπερβαίνει το επιτρεπόμενο μέγεθος των 2 MB.",
  "errors.invalidImageType": "Το επιλεγμένο αρχείο δεν είναι έγκυρη εικόνα.",
  "errors.invalidImageType.title": "Μη έγκυρο αρχείο",
  "errors.invalidImageType.message": "Το επιλεγμένο αρχείο δεν είναι έγκυρη εικόνα.",
  "errors.uploadFailed": "Δεν ήταν δυνατή η μεταφόρτωση της εικόνας. Προσπαθήστε ξανά.",
  "errors.uploadFailed.title": "Σφάλμα κατά τη μεταφόρτωση",
  "errors.uploadFailed.message": "Δεν ήταν δυνατή η μεταφόρτωση της εικόνας. Προσπαθήστε ξανά.",
  "errors.conversationCreate": "Σφάλμα κατά τη δημιουργία συνομιλίας. Δοκιμάστε ξανά.",
  "errors.conversationInvalidId": "Μη έγκυρο αναγνωριστικό συνομιλίας.",
  "errors.conversationOpen": "Σφάλμα κατά το άνοιγμα της συνομιλίας. Δοκιμάστε ξανά.",
  "errors.favoriteUpdate": "Η ενημέρωση των αγαπημένων απέτυχε",
  "errors.blockUpdate": "Δεν ήταν δυνατή η ενημέρωση του κλειδώματος",
  "errors.messageEdit": "Σφάλμα κατά την επεξεργασία του μηνύματος.",
  "errors.generic.403.title": "Σφάλμα πρόσβασης",
  "errors.generic.403.message": "Δεν έχετε άδεια να εκτελέσετε αυτήν την ενέργεια.",
  "errors.saas_max_users": "Το όριο χρήστη του προγράμματος ({current}/{limit}) έχει συμπληρωθεί.",
  "errors.tenant_frozen": "Ο ενοικιαστής είναι προσωρινά αποκλεισμένος.",
  "errors.auth_invalid_credentials": "Λανθασμένο όνομα χρήστη ή κωδικός πρόσβασης.",
  "errors.foundation_sold_out": "Οι θέσεις ιδρυτών έχουν εξαντληθεί.",
  "errors.unexpected_error": "Παρουσιάστηκε απροσδόκητο σφάλμα. Προσπαθήστε ξανά.",
  "errors.accountInactive.title": "Ο λογαριασμός είναι ανενεργός. Συμπληρώστε το email σας για να το ενεργοποιήσετε ξανά.",
  "errors.userInactive.title": "Απενεργοποιημένος λογαριασμός",
  "errors.tenantMismatch.title": "Σφάλμα μισθωτή",
  "errors.accountInactive.activate": "Ενεργοποιήστε τώρα",
  "errors.accountInactive.accept": "Αποδέχομαι",
  "errors.accountInactive.success": "Ο λογαριασμός ενεργοποιήθηκε ξανά. Τώρα μπορείτε να συνδεθείτε.",
  "errors.accountInactive.fail": "Δεν ήταν δυνατή η εκ νέου ενεργοποίηση του λογαριασμού. Προσπαθήστε ξανά.",
  "errors.accountInactive.completeSuccess": "Ο λογαριασμός ενεργοποιήθηκε με το email σας. Τώρα μπορείτε να συνδεθείτε.",
  "errors.accountInactive.completeFail": "Δεν ήταν δυνατή η ολοκλήρωση της ενεργοποίησης. Ελέγξτε το email και δοκιμάστε ξανά.",
  "plan.errors.deviceLimit.title": "Συμπληρώθηκε το όριο του σχεδίου",
  "plan.errors.deviceLimit.message": "Το τρέχον σχέδιό σας έχει όριο στον αριθμό των ταυτόχρονα συνδεδεμένων συσκευών.",
  "plan.errors.deviceLimit.solution": "Για να συνεχίσετε, αποσυνδεθείτε από άλλες συσκευές ή αναβαθμίστε το σχέδιό σας σε PRO.",
  "plan.errors.contactsLimit.title": "Συμπληρώθηκε το όριο επικοινωνίας",
  "plan.errors.contactsLimit.message": "Το τρέχον σχέδιό σας έχει όριο στον αριθμό των επαφών που μπορείτε να έχετε.",
  "plan.errors.contactsLimit.solution": "Για να προσθέσετε περισσότερες επαφές, αναβαθμίστε το σχέδιό σας σε PRO.",
  "plan.errors.invitationsLimit.title": "Συμπληρώθηκε το όριο πρόσκλησης",
  "plan.errors.invitationsLimit.message": "Το τρέχον σχέδιό σας έχει όριο στον αριθμό των προσκλήσεων που μπορείτε να στέλνετε ανά ημέρα.",
  "plan.errors.invitationsLimit.solution": "Για να στείλετε περισσότερες προσκλήσεις, αναβαθμίστε το σχέδιό σας σε PRO.",
  "plan.errors.messagesLimit.title": "Συμπληρώθηκε το όριο μηνυμάτων",
  "plan.errors.messagesLimit.message": "Το τρέχον σχέδιό σας έχει όριο στον αριθμό των μηνυμάτων που μπορείτε να στέλνετε ανά ημέρα.",
  "plan.errors.messagesLimit.solution": "Για να στείλετε περισσότερα μηνύματα, αναβαθμίστε το σχέδιό σας σε PRO.",
  "plan.errors.storageLimit.title": "Συμπληρώθηκε το όριο αποθήκευσης",
  "plan.errors.storageLimit.message": "Το τρέχον σχέδιό σας έχει όριο στον διαθέσιμο χώρο αποθήκευσης.",
  "plan.errors.storageLimit.solution": "Για περισσότερο χώρο αποθήκευσης, κάντε αναβάθμιση σε PRO.",
  "plan.errors.chatsLimit.title": "Συμπληρώθηκε το όριο συνομιλίας",
  "plan.errors.chatsLimit.message": "Το τρέχον σχέδιό σας έχει όριο στον αριθμό των συνομιλιών που μπορείτε να έχετε.",
  "plan.errors.chatsLimit.solution": "Για να δημιουργήσετε περισσότερες συνομιλίες, αναβαθμίστε το σχέδιό σας σε PRO.",
  "plan.errors.upgradeRequired.title": "Απαιτείται αναβάθμιση σχεδίου",
  "plan.errors.upgradeRequired.message": "Αυτή η δυνατότητα απαιτεί ένα υψηλότερο σχέδιο από αυτό που έχετε αυτήν τη στιγμή.",
  "plan.errors.upgradeRequired.solution": "Αναβαθμίστε το σχέδιό σας σε PRO για να αποκτήσετε πρόσβαση σε αυτήν τη δυνατότητα.",
  "appearance.theme.system": "Σύστημα",
  "appearance.theme.corporate": "Εταιρικός",
  "theme.system": "Σύστημα",
  "theme.corporate": "Εταιρικός",
  "founder.modalClose": "Κοντά",
  "founder.activeCountLabel": "Active Founders",
  "founder.urgency.lastSlots": "Διαθέσιμες θέσεις τελευταίου ιδρυτή",
  "founder.positionLabel": "Ιδρυτής #{position} / {limit}",
  "founder.leaderboard.title": "Κορυφαίοι Ιδρυτές",
  'auth.tagline': 'Η δύναμη του να σε καταλαβαίνουν, ανεξάρτητα από τη γλώσσα',
  'auth.sign_in': 'Σύνδεση',
  'auth.create_account': 'Δημιουργία λογαριασμού',
  'ui.search_contact': 'Αναζήτηση επαφής...',
  'ui.language': 'Γλώσσα',
  "contacts.mode": "Τρόπος",
  "contacts.sent": "Στάλθηκε",
  "contacts.actions": "Δράσεις",
  "contacts.pending": "Σκουλαρίκι",
  "contacts.invited_registered": "Επισκέπτης - Εγγεγραμμένος",
  "table.email": "E-mail",
  "table.language": "Γλώσσα",
  "table.mode": "Τρόπος",
  "table.status": "Κατάσταση",
  "table.sent": "Στάλθηκε",
  "table.actions": "Δράσεις",
  "admin.access_denied.message": "Μήνυμα",
  "admin.access_denied.title": "Τίτλος",
  "admin.action.change_plan": "Αλλαγή σχεδίου",
  "admin.action.reactivate": "Επανενεργοποίηση",
  "admin.action.suspend": "Αναστέλλω",
  "admin.action.view": "Θέα",
  "admin.confirm.change_plan.message": "Μήνυμα",
  "admin.confirm.change_plan.title": "Τίτλος",
  "admin.confirm.suspend.message": "Μήνυμα",
  "admin.confirm.suspend.title": "Τίτλος",
  "admin.details.created": "Δημιουργήθηκε",
  "admin.details.current_plan": "Τρέχον σχέδιο",
  "admin.details.domain": "Πεδίο ορισμού",
  "admin.details.last_activity": "Τελευταία δραστηριότητα",
  "admin.details.name": "Γλυκοπατάτα",
  "admin.details.plan": "Σχέδιο",
  "admin.details.status": "Κατάσταση",
  "admin.details.subscription": "Συνδρομή",
  "admin.details.tenant_id": "Ταυτότητα μισθωτή",
  "admin.details.tenant_info": "Πληροφορίες ενοικιαστή",
  "admin.details.usage": "Χρήση",
  "admin.error.change_plan": "Αλλαγή σχεδίου",
  "admin.error.generic": "Γενικός",
  "admin.error.load_details": "Φόρτωση λεπτομερειών",
  "admin.error.load_tenants": "Φορτώστε ενοικιαστές",
  "admin.error.reactivate": "Επανενεργοποίηση",
  "admin.error.suspend": "Αναστέλλω",
  "admin.error.title": "Τίτλος",
  "admin.filter.active": "Δραστηριοποιώ",
  "admin.filter.all_plans": "Όλα τα σχέδια",
  "admin.filter.all_status": "Όλη η κατάσταση",
  "admin.filter.suspended": "Αναστέλλω",
  "admin.limit.devices": "Συσκευές",
  "admin.limit.invitations": "Προσκλήσεις",
  "admin.limit.messages": "μηνύματα",
  "admin.limit.storage": "Αποθήκευση",
  "admin.limit.users": "Χρήστες",
  "admin.loading": "Φόρτωση",
  "admin.no_tenants": "Μη ενοικιαστές",
  "admin.plan.enterprise": "Enterprise",
  "admin.plan.free": "Free",
  "admin.plan.pro": "Pro",
  "admin.status.active": "Δραστηριοποιώ",
  "admin.status.suspended": "Αναστέλλω",
  'admin.subscription.id': 'Id',
  "admin.subscription.last_payment": "Τελευταία πληρωμή",
  "admin.subscription.status": "Κατάσταση",
  "admin.subtitle": "Υπότιτλος",
  "admin.success.plan_changed": "Το σχέδιο άλλαξε",
  "admin.success.tenant_reactivated": "Ενοικιαστής επανενεργοποιήθηκε",
  "admin.success.tenant_suspended": "Ενοικιαστής σε αναστολή",
  "admin.success.title": "Τίτλος",
  "admin.table.actions": "Δράσεις",
  "admin.table.messages": "μηνύματα",
  "admin.table.name": "Γλυκοπατάτα",
  "admin.table.plan": "Σχέδιο",
  "admin.table.status": "Κατάσταση",
  "admin.table.storage": "Αποθήκευση",
  "admin.table.tenant_id": "Ταυτότητα μισθωτή",
  "admin.table.users": "Χρήστες",
  "admin.title": "Τίτλος",
  "admin.usage.devices": "Συσκευές",
  "admin.usage.invitations": "Προσκλήσεις",
  "admin.usage.messages": "μηνύματα",
  "admin.usage.storage": "Αποθήκευση",
  "admin.usage.users": "Χρήστες",
  "auth.login": "Σύνδεση",
  "auth.register": "Μητρώο",
  "auth.reset_password": "επαναφορά κωδικού πρόσβασης",
  "billing.cancel.button": "κουμπί",
  "billing.cancel.canceling": "Ακύρωση",
  "billing.cancel.confirm": "Επιβεβαιώνω",
  "billing.cancel.error": "Λάθος",
  "billing.cancel.success": "επιτυχία",
  "billing.character_billing.characters_used": "Χαρακτήρες που χρησιμοποιούνται",
  "billing.character_billing.consumption_pct": "Κατανάλωση pct",
  "billing.character_billing.days_remaining": "Μέρες έμειναν",
  "billing.character_billing.deletion_date": "Ημερομηνία διαγραφής",
  "billing.character_billing.period_start": "Έναρξη περιόδου",
  "billing.character_billing.renewal_date": "Ημερομηνία ανανέωσης",
  "billing.character_billing.title": "Τίτλος",
  "billing.current_plan": "Τρέχον σχέδιο",
  "billing.founder_badge": "Ιδρυτικό σήμα",
  "billing.no_plans": "Μην σχεδιάζεις",
  'billing.subscription.canceled': 'Canceled',
  'billing.subscription.canceled_note': 'Canceled note',
  "billing.subscription.next_payment": "Επόμενη πληρωμή",
  "billing.subscription.plan": "Σχέδιο",
  'billing.subscription.price': 'Τιμή πλάνου',
  "billing.subscription.started": "Ξεκίνησε",
  "billing.subscription.status": "Κατάσταση",
  "billing.subscription.mp_flow.subscribe_failed": "Δεν ήταν δυνατή η έναρξη της συνδρομής. Προσπαθήστε ξανά.",
  "billing.subscription.mp_flow.change_plan_failed": "Το σχέδιο δεν μπορούσε να αλλάξει. Προσπαθήστε ξανά.",
  "billing.subscription.mp_status.pending": "Σκουλαρίκι",
  "billing.subscription.mp_status.authorized": "Εξουσιοδοτημένος",
  "billing.subscription.mp_status.active": "Ενεργός",
  "billing.subscription.mp_status.paused": "Σε παύση",
  "billing.subscription.mp_status.cancelled": "Ακυρώθηκε",
  "billing.subscription.mp_status.inactive": "Αδρανής",
  "billing.subscription.mp_status.unknown": "Ένας ξένος",
  "billing.unlimited": "Απεριόριστος",
  "billing.update_plan": "Ενημέρωση σχεδίου",
  "billing.update_plan_modal.title": "Τίτλος",
  "billing.usage.loading": "Φόρτωση",
  "common.accept": "Αποδέχομαι",
  "common.confirmPassword": "Επιβεβαίωση κωδικού πρόσβασης",
  "common.error": "Λάθος",
  "dashboard.upgrade.to_plan": "Να προγραμματίσουν",
  "emoji.noResults": "Χωρίς Αποτελέσματα",
  "emoji.pick": "Διαλέγω",
  "export.restricted.message": "Μήνυμα",
  "export.restricted.title": "Τίτλος",
  "export.restricted.upgrade": "Αναβαθμίζω",
  "founder.*": "*",
  "help.faq.a1": "Α1",
  "help.faq.a2": "Α2",
  "help.faq.a3": "Α3",
  "help.faq.a4": "Α4",
  "help.faq.a5": "Α5",
  "help.faq.a6": "Α6",
  "help.faq.a7": "Α7",
  "help.faq.q1": "Q1",
  "help.faq.q2": "Ε2",
  "help.faq.q3": "Ε3",
  "help.faq.q4": "Q4",
  "help.faq.q5": "Q5",
  "help.faq.q6": "Ε6",
  "help.faq.q7": "Ε7",
  "help.faq.title": "Τίτλος",
  "help.howWorks.step4.point7": "Σημείο 7",
  "help.message_time_context.free_vs_pro": "Δωρεάν εναντίον επαγγελματιών",
  "help.message_time_context.point5": "Σημείο 5",
  "help.plans.enterprise.benefits": "Οφέλη",
  "help.plans.enterprise.description": "Περιγραφή",
  "help.plans.enterprise.title": "Τίτλος",
  "help.plans.foundation.devices": "Συσκευές",
  "help.plans.free.description": "Περιγραφή",
  "help.plans.free.devices": "Συσκευές",
  "help.plans.free.limits": "Όρια",
  "help.plans.free.title": "Τίτλος",
  "help.plans.intro": "Εισαγωγή",
  "help.plans.pro.benefits": "Οφέλη",
  "help.plans.pro.description": "Περιγραφή",
  "help.plans.pro.devices": "Συσκευές",
  'help.plans.pro.price': '$19 / μήνα',
  "help.plans.pro.title": "Τίτλος",
  "help.plans.pro.upgrade": "Αναβαθμίζω",
  "help.plans.title": "Τίτλος",
  "help.plans.urgent_slots_badge": "Σήμα επειγόντων κουλοχέρηδων",
  "help.slogan.final": "Τέλος",
  "help.suggestions.point1": "Σημείο 1",
  "help.suggestions.point2": "Σημείο 2",
  "help.suggestions.title": "Τίτλος",
  "invitation.already_contact_added": "Η επαφή έχει ήδη προστεθεί",
  "invitation.already_contact_title": "Ήδη ο τίτλος επικοινωνίας",
  "invitation.already_pending": "Ήδη σε εκκρεμότητα",
  "invitation.language.invalid": "Ακυρος",
  "message.send": "Στέλνω",
  "message.sendFile": "SendFile",
  "messages.conversations": "συνομιλίες",
  "messages.no_conversations_subtitle": "Δεν υπάρχουν υπότιτλοι συνομιλιών",
  "messages.no_conversations_title": "Χωρίς τίτλο συνομιλιών",
  "presence.custom.edit": "Εκδίδω",
  "profile.enrichment.country": "χώρα",
  "profile.enrichment.country.select": "Επιλέγω",
  "profile.enrichment.description": "Περιγραφή",
  "profile.enrichment.org_size": "Μέγεθος οργανισμού",
  "profile.enrichment.org_size.placeholder": "κάτοχος θέσης",
  "profile.enrichment.save": "Εκτός",
  "profile.enrichment.skip": "παραλείπω",
  "profile.enrichment.title": "Τίτλος",
  "profile.enrichment.usage_type.label": "Επιγραφή",
  "profile.enrichment.usage_type.placeholder": "κάτοχος θέσης",
  "profile.founderPosition": "Ιδρυτική Θέση",
  "settings.confirmations.description": "Περιγραφή",
  "settings.confirmations.disable": "Καθιστώ ανίκανο",
  "settings.confirmations.title": "Τίτλος",
  "settings.confirmations.updated": "Ενημερώθηκε",
  "settings.title": "Τίτλος",
  "theme.description": "Περιγραφή",
  "google.unavailable_tenant": "Η Google δεν είναι διαθέσιμη για αυτόν τον μισθωτή.",
  "google.unavailable": "Το Google δεν είναι διαθέσιμο.",
  "google.verify_client_id": "Επαληθεύστε το αναγνωριστικό πελάτη στο Google Cloud Console.",
  'google.login_aria': 'Σύνδεση με Google',
  "message.preview_alt": "Πρεμιέρα",
  "message.image_attachment_alt": "Συνημμένη εικόνα",
  "profile.avatar.alt": "άβαταρ",
  "plan.name.free": "FREE",
  "plan.name.pro": "PRO",
  "plan.name.foundation": "FOUNDATION",
  "plan.name.enterprise": "ENTERPRISE",
  "register.emailPlaceholder": "you@email.com",
  "invitation.top.loading": "Φόρτωση κορυφαίων προσκεκλημένων...",
  "invitation.top.empty": "Δεν υπάρχουν ακόμη επιλεγμένοι προσκεκλημένοι.",
  "invitation.contacts.title": "Πρόσκληση επαφών",
  "invitation.contacts.safe_phase_note": "Ενεργή ασφαλής φάση: οφέλη σε εκκρεμότητα χωρίς επιπτώσεις σε πραγματικά όρια.",
  "invitation.contacts.generate_code": "Δημιουργήστε κωδικό/σύνδεσμο",
  "invitation.contacts.refresh_top3": "Ανανέωση Top 3",
  "invitation.contacts.hide_full_ranking": "Απόκρυψη πλήρους κατάταξης",
  "invitation.contacts.show_full_ranking": "Εμφάνιση πλήρους κατάταξης",
  "invitation.contacts.hide_metrics_dashboard": "Απόκρυψη πίνακα ελέγχου μετρήσεων",
  "invitation.contacts.show_metrics_dashboard": "Εμφάνιση πίνακα ελέγχου μετρήσεων",
  "invitation.contacts.prepared_link_label": "Έτοιμος σύνδεσμος:",
  "invitation.contacts.email_placeholder": "email@domain.com",
  "invitation.contacts.register_pending": "Εγγραφή σε εκκρεμή πρόσκληση",
  "invitation.contacts.status_summary": "Περίληψη κατάστασης",
  "invitation.contacts.sent_invitations": "Έστειλε προσκλήσεις",
  "invitation.contacts.invited_email": "Προσκεκλημένο email",
  "invitation.contacts.code": "κώδικας",
  "invitation.contacts.no_sent_invitations": "Δεν έχω στείλει ακόμη προσκλήσεις.",
  "invitation.contacts.simulated_rewards": "Λήφθηκαν προσομοιωμένες ανταμοιβές",
  "invitation.contacts.no_simulated_rewards": "Δεν υπάρχουν ακόμη προσομοιωμένες ανταμοιβές.",
  "common.id": "ταυτότητα",
  "common.created": "Δημιουργήθηκε",
  "plan.pro_contacts": "Hasta 100 contactos por usuario",
  "common.status": "Κατάσταση",
  'login.prompt_create_account_with_name': 'Θέλετε να δημιουργήσετε λογαριασμό με αυτό το όνομα;',
  'auth.pending_activation.title': 'Ο λογαριασμός εκκρεμεί ενεργοποίηση',
  'auth.pending_activation.body': 'Ο λογαριασμός σας δεν έχει ενεργοποιηθεί ακόμη. Ελέγξτε τα εισερχόμενα και επιβεβαιώστε την εγγραφή σας για να συνδεθείτε στο ArChat.',
  'auth.pending_activation.back_to_login': 'Επιστροφή στη σύνδεση',
  'auth.pending_activation.support_prefix': 'Χρειάζεστε βοήθεια; Επικοινωνήστε με την υποστήριξη:',
  "auth.pending_activation.support_email": "info@archat.com.ar",
  'auth.pending_activation.email_label': 'Email για επανάληψη αποστολής ενεργοποίησης',
  'auth.pending_activation.email_placeholder': 'εσείς@email.com',
  'auth.pending_activation.email_required': 'Εισαγάγετε το email που χρησιμοποιήσατε κατά την εγγραφή για επανάληψη αποστολής ενεργοποίησης.',
  'auth.pending_activation.sent_title': 'Στάλθηκε email ενεργοποίησης',
  'auth.pending_activation.sent_body': 'Αν η διεύθυνση αντιστοιχεί σε εκκρεμή λογαριασμό, στείλαμε νέο σύνδεσμο ενεργοποίησης. Ελέγξτε τα εισερχόμενα και την ανεπιθύμητη αλληλογραφία.',
  'auth.pending_activation.soft_error_title': 'Η επανάληψη αποστολής δεν είναι διαθέσιμη',
  'auth.pending_activation.soft_error_body': 'Δεν ήταν δυνατή η επεξεργασία της επανάληψης αποστολής αυτή τη στιγμή. Δοκιμάστε ξανά σε λίγα λεπτά ή επικοινωνήστε στο info@archat.com.ar.',
  'auth.pending_activation.resend_again': 'Αποστολή ξανά',
  "plans.upgrade.title": "Ενημέρωση σχεδίου",
  "plans.upgrade.comparison": "Σύγκριση σχεδίων",
  'plans.upgrade.billing': '',
  "plans.upgrade.cancel_anytime": "Ακυρώστε όποτε θέλετε",
  "plans.actions.upgrade_pro": "Πηγαίνετε PRO",
  "plans.actions.become_founder": "Γίνε ιδρυτής",

  'plans.modal.card.current_badge': 'Το τρέχον πλάνο σας',

  'plans.modal.card.lower_tier': 'Κάτω από το ενεργό πλάνο σας',

  'plans.modal.card.manage_in_profile': 'Για αλλαγή ή ακύρωση: Συνδρομή και χρέωση στο προφίλ.',
                'plans.modal.card.cancel_subscription': 'Ακύρωση συνδρομής',
                'plans.modal.cancel_confirm.title': 'Ακύρωση ή διαχείριση συνδρομής',
                'plans.modal.cancel_confirm.body': 'Θα ανοίξει νέα καρτέλα με την ασφαλή πύλη Paddle για πληρωμές, τιμολόγια ή ακύρωση.',
                'plans.modal.cancel_confirm.continue_button': 'Συνέχεια',
                'plans.modal.cancel_confirm.back_button': 'Πίσω',
                'plans.modal.cancel_paddle_fallback.title': 'Διαχείριση συνδρομής',
                'plans.modal.cancel_paddle_fallback.body': 'Η πύλη χρέωσης Paddle δεν ανοίγει σε αυτό το περιβάλλον (π.χ. τοπικά ή χωρίς σύνδεση). Μπορείτε να συνεχίσετε να βλέπετε και να συγκρίνετε πλάνα εδώ.',
                'plans.modal.cancel_paddle_fallback.confirm': 'Εντάξει',
  "plans.upgrade_required": "Διατίθεται σε πρόγραμμα PRO",
  'settings.heading': 'Ρυθμίσεις',
  'settings.dashboard': 'Πίνακας',
  'settings.dashboardDescription': 'Τοπικές προτιμήσεις αρχικού πίνακα και ορατών τμημάτων.',
  'settings.dashboardGridHeading': 'Μπλοκ πίνακα',
  'settings.dashboardShowOnStartDescription': 'Όταν είναι ενεργό, μετά τη σύνδεση ανοίγει ο πίνακας αντί για λίστα επαφών.',
  'settings.dashboardBlockWelcome': 'Καλώς ήρθατε',
  'settings.dashboardBlockUsage': 'Χρήση πλάνου',
  'settings.dashboardBlockFiles': 'Τα αρχεία μου',
  'settings.dashboardBlockPromotions': 'Προσφορές',
  'settings.dashboardBlockSessions': 'Συνεδρίες',
  'settings.dashboardWelcomeDescription': 'Πρώτα βήματα, πρόσκληση επαφής και συντομεύσεις βοηθείας.',
  'settings.dashboardUsageDescription': 'Χρήση έναντι ορίων: επαφές, χαρακτήρες, αποθήκευση, συσκευές.',
  'settings.dashboardFilesDescription': 'Περίληψη ορατών αρχείων και χώρου στα «Αρχεία μου».',
  'settings.dashboardPromotionsDescription': 'Περίληψη προσφορών και σύνδεση στο πρόγραμμα.',
  'settings.dashboardSessionsDescription': 'Ενεργές συνεδρίες και συσκευές· κλείσιμο άλλων όπου εφαρμόζεται.',
  'settings.enabled': 'Ενεργό',
  'settings.disabled': 'Ανενεργό',
  'settings.showDashboardOnStart': 'Εμφάνιση πίνακα κατά τη σύνδεση',
  'settings.showWelcomeBlock': 'Μπλοκ καλωσορίσματος',
  'settings.showPromotionsBlock': 'Μπλοκ προσφορών',
  'settings.showUsageBlock': 'Χρήση πλάνου',
  'settings.showRecentConversationsBlock': 'Εμφάνιση πρόσφατων συνομιλιών (τελευταίο μήνυμα ανά επαφή)',
  'settings.showSessionsBlock': 'Ενεργές συνεδρίες',
  'settings.showFilesBlock': 'Περίληψη αρχείων',
  'settings.dashboardLocalNote': 'Οι προτιμήσεις αποθηκεύονται τοπικά μέχρι να υπάρξει API προφίλ.',
  'settings.appearanceSettings': 'Εμφάνιση',
  'settings.argentinaTheme': 'Θέμα Αργεντινή',
  'settings.darkMode': 'Σκοτεινή λειτουργία',
  'settings.language': 'Γλώσσα',
  'settings.messageSound': 'Ήχος μηνυμάτων',
  'settings.playSoundDescription': 'Αναπαραγωγή ήχου για νέα μηνύματα ή σημαντικές ειδοποιήσεις.',
  'settings.messageSoundEnabled': 'Ενεργό',
  'settings.messageSoundDisabled': 'Ανενεργό',
  'settings.accountSettings': 'Λογαριασμός',
  'settings.deleteAccount': 'Διαγραφή λογαριασμού',
  'settings.deleteAccountWarning': 'Η ενέργεια είναι μόνιμη. Τα δεδομένα, μηνύματα, επαφές και ρυθμίσεις σας θα αφαιρεθούν σύμφωνα με τη διαδικασία της πλατφόρμας.',
  'settings.deleteMyAccount': 'Διαγραφή του λογαριασμού μου',
  'dashboard.contacts': 'Επαφές',
  'dashboard.characters': 'Χαρακτήρες',
  'dashboard.storage': 'Αποθηκευτικός χώρος',
  'dashboard.active_devices': 'Ενεργές συσκευές',
  'dashboard.need_more_resources': 'Χρειάζεστε περισσότερους πόρους;',
  'dashboard.upgrade_message': 'Αναβαθμίστε το πλάνο σας για περισσότερες επαφές, χαρακτήρες, αποθηκευτικό χώρο και ενεργές συσκευές.',
  'dashboard.upgrade_button': 'Αναβάθμιση σε PRO',
  'dashboard.upgrade_button_pro': 'Αναβάθμιση σε PRO',
  'dashboard.upgrade_button_foundation': 'Αναβάθμιση σε FOUNDATION',
  'files.preview': 'Προεπισκόπηση',
  'files.previewFile': 'Προεπισκόπηση αρχείου',
  'files.previewUnavailable': 'Η προεπισκόπηση δεν είναι διαθέσιμη.',
  'files.previewLoading': 'Φόρτωση προεπισκόπησης…',
  'files.openPreview': 'Προεπισκόπηση',
  'files.downloadFile': 'Λήψη αρχείου',
  'files.downloadFailed': 'Η λήψη απέτυχε. Ελέγξτε σύνδεση και συνεδρία και δοκιμάστε ξανά.',
  'files.closePreview': 'Κλείσιμο προεπισκόπησης',
  'files.unsupportedPreview': 'Δεν υπάρχει προεπισκόπηση για αυτόν τον τύπο. Δείτε στοιχεία ή κατεβάστε το αρχείο.',
  'files.pdfPreviewHelp': 'Ο περιηγητής μπορεί να μην εμφανίζει ενσωματωμένο PDF. Χρησιμοποιήστε λήψη για άνοιγμα.',
  'files.labelFileType': 'Τύπος',
  'files.previewForbidden': 'Δεν επιτρέπεται η προεπισκόπηση.',
  'files.previewNotFound': 'Το αρχείο δεν είναι διαθέσιμο ή δεν εμφανίζεται πλέον.',
  'files.unavailableForFree': 'Η ενότητα «Τα αρχεία μου» δεν περιλαμβάνεται στο πλάνο FREE.',
  'files.availableInFoundationAndPro': 'Η ενότητα «Τα αρχεία μου» είναι διαθέσιμη στα πλάνα FOUNDATION και PRO.',
  'files.filesFeatureRestricted': 'Η λειτουργία δεν είναι διαθέσιμη στο τρέχον πλάνο σας.',
  'files.filesLoadError': 'Σφάλμα φόρτωσης αρχείων.',
  'files.uploadUnavailableForFree': 'Η αποστολή αρχείων δεν είναι διαθέσιμη στο δωρεάν πλάνο.',
  'files.uploadAvailableInFoundationAndPro': 'Η αποστολή αρχείων είναι διαθέσιμη στα FOUNDATION και PRO.',
  'files.recipientStorageFull': 'Ο παραλήπτης δεν έχει διαθέσιμο χώρο για αυτό το αρχείο.',
  'files.recipientNoAvailableStorage': 'Ο παραλήπτης δεν έχει διαθέσιμο χώρο για αυτό το αρχείο.',
  'files.storageQuotaExceeded': 'Έχετε φτάσει το όριο αποθήκευσης του πλάνου σας.',
  'files.freeStorageLimit': 'Το δωρεάν πλάνο περιλαμβάνει 5 MB αποθήκευσης για ληφθέντα αρχεία.',
  'settings.unreadEmailReminderSection': 'Σύνοψη μη αναγνωσμένων μέσω email',
  'settings.unreadEmailReminderDescription': 'Αν αφήσετε νέα μηνύματα ή αρχεία μη αναγνωσμένα περισσότερο από τον χρόνο παρακάτω, το ArChat στέλνει ένα συγκεντρωτικό email (όχι ένα ανά μήνυμα).',
  'settings.unreadEmailReminderToggle': 'Να στέλνονται συνόψεις στο email μου',
  'settings.unreadEmailDelayHours': 'Αναμονή πριν την αποστολή (ώρες)',
  'settings.unreadEmailDelayHint': '1–168 ώρες (έως μία εβδομάδα). Η γλώσσα email από το προφίλ.',
  'subjects.title': 'Θέματα',
  'subjects.singular': 'Θέμα',
  'subjects.plural': 'Θέματα',
  'subjects.general': 'Γενικά',
  'subjects.new': 'Νέο θέμα',
  'subjects.create': 'Δημιουργία θέματος',
  'subjects.rename': 'Μετονομασία',
  'subjects.finish': 'Ολοκλήρωση',
  'subjects.reopen': 'Επανάνοιγμα',
  'subjects.select': 'Συνέχεια',
  'subjects.status.open': 'Ανοιχτό',
  'subjects.status.pending': 'Εκκρεμές',
  'subjects.status.finished': 'Ολοκληρωμένο',
  'subjects.limitReached': 'Φτάσατε το όριο ενεργών θεμάτων σε αυτή τη συνομιλία. Ολοκληρώστε ένα θέμα για να δημιουργήσετε νέο.',
  'subjects.limitReachedFree': 'Το FREE επιτρέπει έως 3 ενεργά θέματα ανά συνομιλία. Ολοκληρώστε ένα θέμα για να δημιουργήσετε νέο.',
  'subjects.limitReachedPro': 'Το PRO επιτρέπει έως 5 ενεργά θέματα ανά συνομιλία. Ολοκληρώστε ένα θέμα για να δημιουργήσετε νέο.',
  'subjects.limitReachedFoundation': 'Το FOUNDATION επιτρέπει έως 5 ενεργά θέματα ανά συνομιλία. Ολοκληρώστε ένα θέμα για να δημιουργήσετε νέο.',
  'subjects.activeLimitsLine': 'Ενεργά θέματα: {current} / {max}',
  'subjects.closedListTitle': 'Κλειστά θέματα',
  'subjects.viewClosed': 'Προβολή κλειστών θεμάτων',
  'subjects.noClosedSubjects': 'Δεν υπάρχουν κλειστά θέματα.',
  'subjects.reopenSubject': 'Επανάνοιγμα',
  'subjects.reopenedSubjects': 'Ξανάνοιξαν θέματα',
  'subjects.reopenLimitReached':
    'Φτάσατε το όριο ενεργών θεμάτων. Ολοκληρώστε ένα άλλο θέμα για να το ανοίξετε ξανά.',
  'subjects.ownerOnlyReopen': 'Μόνο όποιος δημιούργησε αυτό το θέμα μπορεί να το ανοίξει ξανά.',
  'subjects.modal.title': 'Θέματα συνομιλίας',
  'subjects.modal.subtitle': 'Επιλέξτε ή διαχειριστείτε τα θέματα αυτής της συνομιλίας.',
  'subjects.contactLabel': 'ΕΠΑΦΗ:',
  'subjects.ownerOnlyRename': 'Μόνο ο δημιουργός του θέματος μπορεί να αλλάξει το όνομα.',
  'subjects.ownerOnlyStateChange': 'Μόνο ο δημιουργός του θέματος μπορεί να αλλάξει την κατάσταση.',
  'subjects.createdByOther': 'Αυτό το θέμα δημιουργήθηκε από την άλλη πλευρά. Μπορείτε να απαντήσετε, αλλά όχι να μετονομάσετε.',
  'subjects.empty': 'Δεν υπάρχουν θέματα προς εμφάνιση.',
  'subjects.noResults': 'Δεν βρέθηκαν θέματα.',
  'subjects.error.generic': 'Η ενέργεια δεν ολοκληρώθηκε. Δοκιμάστε ξανά.',
  'subjects.error.featureDisabled': 'Τα θέματα δεν είναι διαθέσιμα σε αυτό το περιβάλλον.',
  'subjects.error.duplicateName': 'Υπάρχει ήδη ενεργό θέμα με αυτό το όνομα.',
  'subjects.error.ownerRequired': 'Δεν έχετε άδεια να τροποποιήσετε αυτό το θέμα.',
  'subjects.error.defaultCannotRename': 'Το θέμα «Γενικά» δεν μπορεί να μετονομαστεί.',
  'subjects.error.defaultCannotFinish': 'Το θέμα «Γενικά» δεν μπορεί να ολοκληρωθεί.',
  'subjects.current': 'Θέμα',
  'subjects.change': 'Αλλαγή θέματος',
  'subjects.currentLabel': 'Θέμα:',
  'subjects.changeSubject': 'Αλλαγή θέματος',
  'subjects.closedCannotSend': 'Αυτό το θέμα έχει ολοκληρωθεί. Ανοίξτε το ξανά για να στείλετε νέα μηνύματα.',
  'subjects.selectBeforeSend': 'Επιλέξτε ένα θέμα στο παράθυρο για να δείτε τα μηνύματα και να στείλετε.',
  'subjects.loadingMessages': 'Φόρτωση μηνυμάτων για αυτό το θέμα…',
  'subjects.messageFilterError': 'Δεν ήταν δυνατή η φόρτωση μηνυμάτων για αυτό το θέμα.',
  ...PRESET_LOCALES.el,
  "auth.login.clear_password_lock_after_reset": "Έχω ήδη αλλάξει τον κωδικό πρόσβασής μου (π.χ. σε άλλη συσκευή)",
  "auth.signup_disabled": "Η εγγραφή νέου λογαριασμού είναι προσωρινά απενεργοποιημένη σε αυτό το περιβάλλον.",
  "auth.reset_user_not_found": "Δεν βρήκαμε λογαριασμό που να σχετίζεται με αυτό το email. Ελέγξτε ότι είναι σωστά γραμμένο ή δημιουργήστε νέο λογαριασμό.",
  "account.not_found": "Ο λογαριασμός δεν βρέθηκε.",
  "menu.plans": "Σχέδια",
  "files.title": "τα αρχεία μου",
  "files.filter_all": "Ολοι",
  "files.filter_sent": "Στάλθηκε",
  "files.filter_received": "Ελήφθη",
  "files.filter_images": "εικόνες",
  "files.filter_documents": "Εγγραφα",
  "files.col_name": "Ονομα",
  "files.col_size": "Μέγεθος",
  "files.col_date": "Ημερομηνία",
  "files.col_direction": "Σκην.",
  "files.col_actions": "Δράσεις",
  "files.sent": "📤 Στάλθηκε",
  "files.received": "📥 Ελήφθη",
  "files.download": "Εκπλήρωση",
  "files.delete_for_me": "Διαγραφή για μένα",
  "files.delete_confirm_title": "Διαγραφή αρχείου",
  "files.delete_confirm_message": "Αυτό το αρχείο θα διαγραφεί από τον λογαριασμό σας. Δεν θα διαγραφεί για το άλλο άτομο. Συνεχίζω;",
  "files.empty": "Δεν έχετε αρχεία.",
  "files.error_loading": "Σφάλμα κατά τη μεταφόρτωση αρχείων.",
  "files.load_more": "Φορτώστε περισσότερα",
  "message.status.sending": "Αποστολή…",
  "message.status.failed": "Δεν εστάλη",
  "message.status.sent": "Στάλθηκε",
  "message.status.delivered": "Παραδόθηκε",
  "message.status.read": "Ανάγνωση",
  "home.public_nav.pricing": "Τιμές",
  "home.public_nav.aria": "Πλοήγηση στον κύριο ιστότοπο",
  "home.public_footer.aria": "Νομικοί σύνδεσμοι",
  "home.pricing_link": "Σχέδια και τιμές",
  "publicPricing.nav.back_home": "← Αρχική σελίδα",
  "publicPricing.title": "Σχέδια και τιμές",
  "publicPricing.subtitle": "Διαφανή και ευθυγραμμισμένα όρια στη μηχανή συνδρομής ArChat. Εμπορικές τιμές σε USD για διεθνείς αγορές (π.χ. Paddle).",
  "publicPricing.commercial_note": "Τα λειτουργικά όρια προέρχονται από το PlanConstants/PlanResolver. ο λογαριασμός σας μπορεί να εφαρμόσει plan_limits στη βάση δεδομένων. Η χρέωση εμπόρου χρησιμοποιεί το Paddle (ή άλλους επεξεργαστές που ορίζονται επίσημα από το ArChat) με τιμολόγηση σε USD όπως υποδεικνύεται.",
  "publicPricing.plan.free": "FREE",
  "publicPricing.plan.foundation": "FOUNDATION",
  "publicPricing.plan.pro": "PRO",
  "publicPricing.price.free": "USD 0 / mes",
  "publicPricing.price.foundation": "USD {price} / mes",
  "publicPricing.price.pro": "USD {price} / mes",
  "publicPricing.same_limits_pro": "Ίδια τεχνικά όρια με το PRO (συμβόλαιο premium).",
  "publicPricing.same_limits_foundation": "Ίδια τεχνικά όρια με το FOUNDATION (συμβόλαιο premium).",
  "publicPricing.badge.foundation": "Programa Founder",
  "publicPricing.badge.pro": "Recomendado",
  "publicPricing.free.b1": "30.000 χαρακτήρες το μήνα ανά λογαριασμό.",
  "publicPricing.free.b2": "Έως 2 επαφές ανά χρήστη. έως 2 ενεργές συνομιλίες ανά λογαριασμό.",
  "publicPricing.free.b3": "Χωρίς συνημμένα ή αποθηκευτικό χώρο. χωρίς εξαγωγή δεδομένων.",
  "publicPricing.free.b4": "Ιστορικό μηνυμάτων έως 30 ημέρες. 1 συσκευή ανά χρήστη.",
  "publicPricing.free.b5": "34 μηνύματα/ημέρα και 1.000 μηνύματα/μήνα (ενοικιαστής). έως 20 προσκλήσεις την ημέρα.",
  "publicPricing.premium.b1": "300.000 χαρακτήρες ανά μήνα ανά λογαριασμό. έως 100 επαφές ανά χρήστη.",
  "publicPricing.premium.b2": "Απεριόριστες συνομιλίες και συνομιλίες (ενοικιαστής). 1.667 μηνύματα/ημέρα και 50.000/μήνα.",
  "publicPricing.premium.b3": "Αποθηκευτικός χώρος έως 50 MB (ενοικιαστής). έως 3 συσκευές ανά χρήστη.",
  "publicPricing.premium.b4": "Απεριόριστες προσκλήσεις (ενοικιαστής). εξαγωγή, αυτόματη μετάφραση και αρχεία σύμφωνα με το σχέδιο.",
  "publicPricing.premium.b5": "FOUNDATION: ίδιο τεχνικό συμβόλαιο με το PRO, συν το πρόγραμμα Founder (150 θέσεις). PRO: premium standard.",
  "publicPricing.foundation.founder_note": "Ιδρυτικό εμπορικό πρόγραμμα: περιορισμένος αριθμός θέσεων {slots} (δείτε περίληψη σχεδίου). Τα ίδια όρια PRO μόλις ενεργοποιηθεί η συνδρομή.",
  "publicPricing.cta.start_free": "Δημιουργία δωρεάν λογαριασμού",
  "publicPricing.cta.register_paid": "Δημιουργία λογαριασμού",
  "publicPricing.paddle_hint": "Το checkout με τον επιλεγμένο επεξεργαστή θα ολοκληρωθεί εντός της εφαρμογής όταν ενεργοποιηθεί η φόρτιση.",
  "publicPricing.legal.nav_label": "Νομικός",
  "publicPricing.legal.terms": "Όροι παροχής υπηρεσιών",
  "publicPricing.legal.privacy": "Πολιτική Απορρήτου",
  "publicPricing.legal.refund": "Πολιτική επιστροφής χρημάτων",
  "profile.security.privacy_note": "Διαχειριστείτε το απόρρητο και την ασφάλεια του λογαριασμού σας.",
  "profile.security.sessions_title": "Ενεργές συνεδρίες",
  "profile.security.current": "Τρέχουσα συνεδρία",
  "profile.plan.foundation.description": "FOUNDATION Plan (Founder): ίδια premium χρήση με το PRO, με πρόγραμμα Founder και περιορισμένο χώρο (150 θέσεις).",
  "billing.view_plans": "Δείτε σχέδια",
  "billing.paddle.cancel_via_portal": "Ακύρωση συνδρομής",
  "billing.paddle.test_access_denied_body": "Σε αυτόν τον διακομιστή, οι λειτουργίες χρέωσης είναι περιορισμένες (λειτουργία δοκιμής ή λίστα δοκιμής). Εάν έχετε ήδη πληρώσει με πραγματικό λογαριασμό, κατά την παραγωγή η πληρωμή πρέπει να επιτρέπεται για όλους τους χρήστες (π.χ. PAYMENTS_ALLOW_ALL_BILLING_USERS) ή αυτός ο περιορισμός πρέπει να απενεργοποιηθεί. Επικοινωνήστε με την υποστήριξη.",
  "attachment.storage_insufficient_precheck.title": "Ανεπαρκής χώρος",
  "attachment.storage_insufficient_precheck.message": "Το αρχείο ζυγίζει {fileSizeMb} MB και έχετε διαθέσιμα μόνο {availableMb} MB. Απελευθερώστε χώρο ή βελτιώστε το σχέδιό σας για να συνεχίσετε.",
  "attachment.files_disabled.title": "Όριο σχεδίου",
  "attachment.files_disabled.message": "Το τρέχον σχέδιό σας δεν περιλαμβάνει αποστολή αρχείων. Βελτιώστε το σχέδιό σας για να συνεχίσετε.",
  "contacts.viewContactInfo": "Δείτε τα στοιχεία επικοινωνίας",
  "contacts.contactInfoTitle": "Στοιχεία επικοινωνίας",
  "contacts.phone": "Τηλέφωνο",
  "contacts.bio": "Βιογραφία",
  "contacts.notProvided": "Απληροφόρητος",
  "contacts.unread.badge": "Μη αναγνωσμένα μηνύματα",
  "dashboard.recentInbound.title": "Λήφθηκαν τελευταία μηνύματα",
  "dashboard.recentInbound.empty": "Δεν έχετε λάβει πρόσφατα μηνύματα.",
  "dashboard.recentInbound.error": "Δεν ήταν δυνατή η φόρτωση των μηνυμάτων.",
  "dashboard.recentInbound.previewPhoto": "Φωτογραφία",
  "dashboard.recentInbound.previewFile": "Αρχείο",
  "dashboard.recentInbound.previewPdf": "PDF",
  "dashboard.recentInbound.previewUnavailable": "Το μήνυμα δεν είναι διαθέσιμο",
  "dashboard.recentInbound.readTitle": "Ανάγνωση",
  "dashboard.recentInbound.unreadTitle": "αδιάβαστος",
  "dashboard.recentConversations.title": "Πρόσφατες συνομιλίες",
  "dashboard.recentConversations.empty": "Δεν υπάρχουν συνομιλίες για εμφάνιση.",
  "dashboard.recentConversations.error": "Δεν ήταν δυνατή η φόρτωση των συνομιλιών.",
  "dashboard.plan.foundation": "FOUNDATION",
  "plan.errors.translationNotAllowed.title": "Η μετάφραση δεν είναι διαθέσιμη",
  "plan.errors.translationNotAllowed.message": "Το τρέχον σχέδιό σας δεν περιλαμβάνει αυτόματη μετάφραση μεταξύ γλωσσών.",
  "plan.errors.translationNotAllowed.solution": "Για να χρησιμοποιήσετε την αυτόματη μετάφραση, αναβαθμίστε το σχέδιό σας.",
  "billing.subscription.cancel_scheduled_date": "Η συνδρομή σας έχει προγραμματιστεί να ακυρωθεί στις {{ημερομηνία}}. Μπορείτε να συνεχίσετε να χρησιμοποιείτε το σχέδιό σας μέχρι τότε.",
  "billing.subscription.cancel_scheduled_badge": "Ακυρώθηκε στις {{date}}",
  "billing.scheduled.plan_after_cancel_label": "Σχέδιο στο τέλος της περιόδου:",
  "billing.scheduled.plan_free": "FREE (gratuito)",
  "billing.scheduled.plan_foundation": "FOUNDATION",
  "billing.scheduled.switch_to_foundation": "Αλλαγή σε FOUNDATION",
  "billing.scheduled.switch_to_free": "Αλλαγή σε ΔΩΡΕΑΝ",
  "billing.scheduled.foundation_full_title": "FOUNDATION δεν είναι διαθέσιμο",
  "billing.scheduled.foundation_full_message": "Δεν υπάρχουν διαθέσιμες θέσεις FOUNDATION αυτήν τη στιγμή. Το πρόγραμμά σας θα γίνει ΔΩΡΕΑΝ στο τέλος της περιόδου.",
  "billing.scheduled.saving": "Οικονομία...",
  "billing.scheduled.error_title": "Σφάλμα κατά την αλλαγή σχεδίου",
  "billing.scheduled.error_generic": "Το προγραμματισμένο σχέδιο δεν μπορούσε να αλλάξει. Προσπαθήστε ξανά.",
  "billing.cancel_scheduled.title": "Προγραμματισμένη ακύρωση",
  "billing.cancel_scheduled.desc": "Η συνδρομή σας θα ακυρωθεί στις {{ημερομηνία}}. Μπορείτε να συνεχίσετε να χρησιμοποιείτε το τρέχον πρόγραμμά σας μέχρι τότε.",
  "billing.cancel_scheduled.no_new_plan_until_end": "Μέχρι να λήξει αυτή η συνδρομή, δεν θα μπορείτε να συνάψετε άλλο πρόγραμμα.",
  "billing.cancel_scheduled.free_fallback": "Εάν δεν ανανεώσετε κανένα πρόγραμμα, ο λογαριασμός σας θα συνεχίσει ΔΩΡΕΑΝ με τους αντίστοιχους περιορισμούς.",
  "billing.cancel_scheduled.profile_deactivation_hint": "Μπορείτε επίσης να διαγραφείτε από την πλατφόρμα από το προφίλ σας.",
  "billing.cancel_scheduled.default_free": "Στο τέλος της περιόδου: ΔΩΡΕΑΝ",
  "google.missing_client_id": "Η Είσοδος Google δεν είναι διαθέσιμη σε αυτήν την έκδοση: λείπει το VITE_GOOGLE_CLIENT_ID (ή το googleClientId ανά μισθωτή σε __ARCHAT_TENANT_CONFIG__).",
  "reviews.title": "Κριτικές ArChat",
  "reviews.create_title": "Πώς θα βαθμολογούσατε το ArChat;",
  "reviews.edit_title": "Επεξεργασία της κριτικής μου",
  "reviews.comment_placeholder": "Πείτε μας για την εμπειρία σας (προαιρετικά)...",
  "reviews.submit_btn": "Υποβολή κριτικής",
  "reviews.update_btn": "Εκσυγχρονίζω",
  "reviews.thank_you": "Ευχαριστούμε για την κριτική σας!",
  "reviews.submitted_message": "Η γνώμη σας μας βοηθά να βελτιωθούμε.",
  "reviews.error_select_rating": "Επιλέξτε μια βαθμολογία",
  "reviews.error_generic": "Σφάλμα κατά την υποβολή κριτικής",
  "reviews.prompt_message": "Σας αρέσει το ArChat; Αφήστε την κριτική σας!",
  "reviews.rate_now": "Γίνομαι αρμόδιος",
  "reviews.later": "Αργότερα",
  "reviews.write_review": "Γράψτε κριτική",
  "reviews.edit_my_review": "Επεξεργασία της κριτικής μου",
  "reviews.no_reviews": "Δεν υπάρχουν ακόμα κριτικές. Γίνε ο πρώτος!",
  "reviews.review_singular": "κριτική",
  "reviews.review_plural": "κριτικές",
  "reviews.verified": "Επαληθεύτηκε",
  "reviews.anonymous": "Ανώνυμος",
  "files.storageUsed": "Μεταχειρισμένος χώρος",
  "files.planQuota": "Σχέδιο ποσόστωσης",
  "files.availableStorage": "Διαθέσιμος",
  "files.usagePercent": "μεταχειρισμένος",
  "files.unlimited": "Απεριόριστος",
  "files.sentBy": "Αποστολή από",
  "files.unknownUser": "Μεταχειριζόμενος",
  "settings.webPushSection": "Ειδοποιήσεις συστήματος (push/PWA)",
  "settings.webPushDescription": "Επιτρέπει ειδοποιήσεις όταν η εφαρμογή είναι στο παρασκήνιο ή κλειστή στο κινητό. Απαιτεί VAPID δημόσιο κλειδί στο build (VITE_VAPID_PUBLIC_KEY) και κλειδιά στον διακομιστή. Ενεργοποιήστε την άδεια του προγράμματος περιήγησης και καταχωρήστε αυτήν τη συσκευή.",
  "settings.webPushButton": "Ενεργοποιήστε τις ειδοποιήσεις push",
  "settings.webPushRegistering": "Εγγραφή…",
  "settings.webPushState.granted": "Χορηγήθηκε άδεια. Εάν το VAPID έχει ρυθμιστεί σωστά, το αρχείο καταγραφής στάλθηκε στον διακομιστή.",
  "settings.webPushState.denied": "Η άδεια απορρίφθηκε. Ενεργοποιήστε τις ειδοποιήσεις για αυτόν τον ιστότοπο στις ρυθμίσεις του προγράμματος περιήγησής σας.",
  "settings.webPushState.default": "Πατήστε το κουμπί για να ζητήσετε άδεια και να καταχωρήσετε τη συσκευή.",
  "settings.webPushState.unsupported": "Αυτό το πρόγραμμα περιήγησης δεν υποστηρίζει ειδοποιήσεις push.",
  "settings.webPushVapidMissing": "Το VITE_VAPID_PUBLIC_KEY λείπει από αυτήν την έκδοση διεπαφής: δεν είναι δυνατή η ολοκλήρωση της συνδρομής push.",
  "tags.etiquetas": "ετικέτες",
  "tags.manageTitle": "Διαχείριση ετικετών",
  "tags.manage": "🏷️ Ετικέτες",
  "tags.allTags": "Όλες οι ετικέτες",
  "tags.confirmDelete": "Κατάργηση αυτής της ετικέτας;",
  "tags.tagNamePlaceholder": "Όνομα ετικέτας",
  "tags.create": "Δημιουργώ",
  "tags.noTags": "Δεν υπάρχουν ετικέτες. Δημιουργήστε ένα παραπάνω.",
  "tags.save": "Διατήρηση",
  "tags.edit": "Εκδίδω",
  "tags.delete": "Εξαλείφω",
  "tags.assignTo": "Αναθέστε σε",
  "tags.noTagsToAssign": "Δεν υπάρχουν διαθέσιμες ετικέτες. Δημιουργήστε τα πρώτα.",
  "tags.bgColor": "χρώμα φόντου",
  "tags.textColor": "Χρώμα κειμένου",
  "tags.selectTag": "Επιλέξτε μια ετικέτα",
  "templates.selectTitle": "Πρότυπα",
  "templates.noTemplates": "Δεν υπάρχουν πρότυπα. Δημιουργήστε ένα παραπάνω.",
  "templates.manage": "Διαχείριση προτύπων",
  "templates.confirmDelete": "Διαγραφή αυτού του προτύπου;",
  "templates.manageTitle": "Διαχείριση προτύπων",
  "templates.titlePlaceholder": "Τίτλος προτύπου",
  "templates.bodyPlaceholder": "Έγραψα το πρότυπο μήνυμα...",
  "templates.create": "Δημιουργία προτύπου",
  "templates.save": "Διατήρηση",
  "templates.edit": "Εκδίδω",
  "templates.delete": "Εξαλείφω",
};

